import React from "react";
import { connect } from "react-redux";
import _ from "lodash";
import { professionalAction } from "../../_actions";
import {
  Button,
  DatePicker,
  PageHeader,
  Descriptions,
  Form,
  Select,
  Space,
  Spin,
  Modal,
  Drawer,
  Input,
  Menu,
  Dropdown,
  Radio,
  message,
  Card,
  Row,
  Col,
  Table,
} from "antd";
import {
  Tooltip,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
} from "recharts";
import {
  DocumentCount,
  PreventiveDocument,
} from "./ReportDocuments/Document_2";
import { saveAs } from "file-saver";
import { pdf } from "@react-pdf/renderer";
import { Option } from "antd/lib/mentions";
import moment from "moment";
import { ProfessionalForm } from "../ProfessionalForm/ProfessionalForm";
import {
  ArrowDownOutlined,
  ArrowUpOutlined,
  CheckCircleOutlined,
  ClockCircleOutlined,
  DownOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import ReportsTable from "./ReportsTable";
import * as XLSX from "xlsx-js-style";
import { TablePreventiveReport } from "./Tables/preventiveTabel1";
import { ViewFormModel } from "./ViewForm/ViewFormModel";
import { LanguageContext } from "../../context/LanguageContext";
import {
  BarChartOutlined,
  UnorderedListOutlined,
  SearchOutlined,
  ClearOutlined,
  SafetyCertificateOutlined,
  DisconnectOutlined,
  BankOutlined,
  TrophyOutlined,
  CalendarOutlined,
} from "@ant-design/icons";
import { roleAction } from "../../_actions/roleby.action";
import { notificationAction } from "../../_actions/notifications.actions";
import { adminService } from "../../_services/admin.service";
import { mapAdminCityAction } from "../../_actions/mapAdminCity.action";
import {
  downloadReportPdf,
  getDefaultReportFooter,
  getReportDateRangeText,
  getReportHeaderText,
} from "../../_helpers/downloadReportPdf";
import { ViewGunaDetails } from "../viewGunaDetails/viewGunaDetails";
import "../Dashboard/adminNewDashboard.css";
const { RangePicker } = DatePicker;

const NewReport1 = React.lazy(() =>
  import("./Tables/TableCount").then((module) => ({
    default: module.PreventiveCountReports,
  })),
);

const Reports1 = React.lazy(() =>
  import("./Tables/TablePreventive").then((module) => ({
    default: module.PreventiveReports1,
  })),
);

const ANALYTICS_PIE_COLORS = [
  "#1890ff",
  "#fa8c16",
  "#52c41a",
  "#722ed1",
  "#13c2c2",
  "#bfbfbf",
];

class ReportPreventive extends React.Component {
  static contextType = LanguageContext;
  constructor(props) {
    super(props);
    this.myTableRef = React.createRef();
  }

  state = {
    activeRange: "daily",
    is_data: false,
    key: "",
    searchText: "",
    loading: false,
    downloadLoding: false,
    report_3_startDate: "",
    report_3_endDate: "",
    report_1_endDate: "",
    report1_loader: false,
    report3_loader: false,
    reportList: [],
    reportList1: [],
    reportList_Total: null,
    report1_API_loader: false,
    report1_Total: null,
    showList:
      this.props.user && this.props.user.role === "2" ? "यादी" : "सांख्यिकी",
    report_1_startDate: "",
    report_1_endDate: "",
    preventiveAction: [],
    preventiveList: [],
    report: false,
    preventive_action_mode: "चालु प्रतिबंधक कारवाही",
    selectedDate: moment(),
    download: "excel",
    setCriminalViewModel: false,
    selectedHeadings: [],
    showFilterSection: false,
    year: [],
    order_by: "",
    direction: "",
    is_sort: false,
    preventiveListCount: [],
    advancedFilterPhoto: "all",
    mapped_cities: [],
    selected_city: "",
    analytics_range: "1month",
    analytics_startDate: moment()
      .subtract(1, "month")
      .startOf("day")
      .toISOString(),
    analytics_endDate: moment().endOf("day").toISOString(),
    analytics_loading: false,
    analytics_fetched: false,
    analytics_data: null,
    analytics_list_visible: false,
    analytics_list_loading: false,
    analytics_list_title: "",
    analytics_list_district_name: "",
    analytics_list_rows: [],
    analytics_list_type: "",
    analytics_list_page: 1,
    analytics_list_page_size: 10,
    analytics_pie_loading: false,
    analytics_pie_title: "",
    analytics_pie_data: [],
    analytics_drill_mode: "preventive",
    analytics_selected_district: "",
    analytics_selected_district_id: null,
    analytics_filter_preventive_action: null,
    analytics_filter_preventive_action_name: "",
    analytics_completed_days: 7,
    analytics_completed_direction: "upcoming",
    showAnalytics: false,
    showGunaDetails: false,
    gunaLoading: false,
  };
  componentDidUpdate(prevProps) {
    // Check if the data has just arrived
    const prevList = prevProps.professionals?.criminalViewList?.gunhaInfor;
    const currList = this.props.professionals?.criminalViewList?.gunhaInfor;
    if (this.state.gunaLoading && prevList !== currList) {
      this.setState({ gunaLoading: false });
    }
  }
  userMapCityDetails = () => {
    let temp = {
      id: this.props.user.id,
    };
    mapAdminCityAction.userMapCityDetails(temp).then((res) => {
      console.log("res mapped", res.results);
      this.setState({
        mapped_cities: res.results,
      });
    });
  };
  setQuickRange = (type) => {
    let startDate = null;

    switch (type) {
      case "daily":
        startDate = moment();
        break;

      case "weekly":
        const now = moment();
        startDate = now.clone().startOf("isoWeek");
        break;

      case "month":
        startDate = moment().startOf("month");
        break;

      case "custom":
        startDate = null;
        break;

      default:
        startDate = null;
    }

    this.setState({
      selectedDate: startDate,
      activeRange: type,
    });
  };
  getExportRows = () => {
    const { t } = this.context;
    const excludeColumns = [
      "Sr.No",
      "districtId",
      "districtName",
      "actionTakenPoliceStation",
      "सीआरपीसी कलम 110",
    ];

    const newArrayWithTotal = this.state.preventiveListCount.map(
      (item, index) => {
        const { districtId, ["सीआरपीसी कलम 110"]: _, ...restItem } = item;

        const total = Object.keys(restItem).reduce((sum, key) => {
          if (excludeColumns.includes(key) || isNaN(restItem[key])) {
            return sum;
          }
          return sum + Number(restItem[key]);
        }, 0);

        return {
          [t("पोलिस ठाणे")]: item.districtName || item.actionTakenPoliceStation,
          [t("total")]: total,
          ["बी एन एस एस १२६"]: item["बी एन एस एस १२६"],
          ["बी एन एस एस १२७"]: item["बी एन एस एस १२७"],
          ["बी एन एस एस १२८"]: item["बी एन एस एस १२८"],
          ["बी एन एस एस १२९"]: item["बी एन एस एस १२९"],
          ["मपोका कलम 68/69"]: item["मपोका कलम 68/69"],
          ["मपोका कलम 55"]: item["मपोका कलम 55"],
          ["मपोका कलम 56"]: item["मपोका कलम 56"],
          ["मपोका कलम 57"]: item["मपोका कलम 57"],
          ["मंबई दारूबंदी कायदा कलम 93"]: item["मंबई दारूबंदी कायदा कलम 93"],
          ["महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)"]:
            item["महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)"],
          ["सीआरपीसी कलम 109"]: item["सीआरपीसी कलम 109"],
          ["सीआरपीसी कलम 151"]: item["सीआरपीसी कलम 151"],
          ["सीआरपीसी कलम 144 (3)"]: item["सीआरपीसी कलम 144 (3)"],
        };
      },
    );
    var arrData1 =
      this.state.showList == "सांख्यिकी"
        ? newArrayWithTotal
        : this.state.preventiveList;
    return arrData1;
  };

  download_pdf = async () => {
    const { preventive_action_mode, showList } = this.state;
    const { t } = this.context;
    const arrData = this.getExportRows();

    if (!arrData.length) {
      message.warning(t("no_data_available") || "No data available");
      return;
    }

    const title =
      preventive_action_mode === "प्रतिबंधक कारवाईचे उल्लंघन"
        ? "प्रतिबंधक कारवाईचे उल्लंघन करणाऱ्या आरोपीचे" + " - " + showList
        : preventive_action_mode + " - ";
    var ReportTitle =
      preventive_action_mode === "प्रतिबंधक कारवाईचे उल्लंघन"
        ? "प्रतिबंधक कारवाईचे उल्लंघन करणाऱ्या आरोपीचे" + " - " + showList
        : preventive_action_mode + " - " + showList;
    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;
    const headerText = getReportHeaderText({
      user: this.props?.user,
      cityName: this.getCityName(this.props?.user?.cityId || ""),
      districtName: this.state.district_name,
    });

    this.setState({ downloadLoding: true });
    try {
      await downloadReportPdf({
        headerText,
        reportTitle: ReportTitle,
        dateRangeText: getReportDateRangeText(
          this.state.report_1_startDate,
          this.state.report_1_endDate,
        ),
        arrData,
        fileName: file_name,
        footerText: getDefaultReportFooter(),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to generate PDF report");
    } finally {
      this.setState({ downloadLoding: false });
    }
  };

  downloadReport = () => {
    const { download } = this.state;
    if (download == "excel") {
      this.download_csv();
    }
    if (download == "pdf") {
      this.download_pdf();
    }
  };

  getDistrictsid = () => {
    const { user } = this.props;
    console.log("users id", this.props);
    professionalAction.getDistrictsid(user.districtId).then((res) => {
      console.log("res", res);

      const tempData = res.pc_districts;
      console.log("text", tempData[0]?.DistrictName);
      this.setState({
        district_name: tempData[0]?.DistrictName,
      });
    });
  };
  componentDidMount() {
    if (this.props?.user?.role === "2") {
      this.getDistrictsid();
    }
    this.props.dispatch(professionalAction.getCity());
    const { state } = this.props.location;
    const dashboardFlag = state?.dashboardFlag || false;

    if (dashboardFlag) {
      this.setPrevetiveMode("चालु प्रतिबंधक कारवाही");
    }
    this.getPreventiveInfo();
    if (this.props.user && this.props.user.role === "2") {
      this.setPrevetiveMode("चालु प्रतिबंधक कारवाही");
      this.getOngoingPreventiveActionList();
    } else if (dashboardFlag) {
      this.getOngoingPreventiveActionCount();
    }
    if (this.props.user.role === "12") {
      this.userMapCityDetails();
    }
    this.props.dispatch(professionalAction.getCrimeTitle());
  }
  getPreventiveActionsNotSendNotification = () => {
    this.setState({
      report1_API_loader: true,
    });

    const {
      selectedDate,
      preventive_action,
      selectedHeadings,
      searchText,
      year,
      order_by,
      direction,
      report_1_startDate,
      report_1_endDate,
      activeRange,
    } = this.state;
    const { user } = this.props;
    console.log("selectedHeadings ongoin", selectedHeadings);
    const temp = {
      city:
        user.role === "12"
          ? this.state.selected_city
          : user.role === "4" && user.cityId,
      preventive_action: selectedHeadings.length > 0 ? selectedHeadings : [],
      search: searchText ? searchText : "",
      year: year.length > 0 ? year : [],
      order_by: order_by ? order_by : "",
      direction: direction ? direction : "",
      district:
        user.role === "9" || user.role === "10"
          ? user.map_districtId
          : user.role === "2" && [user.districtId],
      endDate:
        activeRange === "custom"
          ? moment(report_1_endDate).format("YYYY-MM-DD")
          : moment(selectedDate).format("YYYY-MM-DD"),
      rangeType: activeRange,
      startDate:
        activeRange === "custom" &&
        moment(report_1_startDate).format("YYYY-MM-DD"),
    };
    adminService.getPreventiveActionViolators(temp).then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("preventive notification", criminalList);
          if (criminalList.results.length > 0) {
            this.setState({
              is_data: true,
            });
          }
          this.setState({
            preventiveList: criminalList.results,
            report1_API_loader: false,
            reportList: criminalList.results,
            reportList1: criminalList.results,
          });
          if (order_by && direction) {
            this.setState({
              is_sort: true,
            });
          }
        });
    });
    // if (user.role === "4") {
    //   const data = {
    //     startDate: moment(selectedDate).format("YYYY-MM-DD"),
    //     city: user.cityId,
    //     preventive_action: selectedHeadings.length > 0 ? selectedHeadings : [],
    //     search: searchText ? searchText : "",
    //     year: year.length > 0 ? year : [],
    //     order_by: order_by ? order_by : "",
    //     direction: direction ? direction : "",
    //   };
    //   notificationAction
    //     .getPreventiveActionsNotSendNotification(data)
    //     .then((res) => {
    //       res &&
    //         res.json().then((criminalList) => {
    //           console.log("preventive notification", criminalList);
    //           if (criminalList.results.length > 0) {
    //             this.setState({
    //               is_data: true,
    //             });
    //           }
    //           this.setState({
    //             preventiveList: criminalList.results,
    //             report1_API_loader: false,
    //             reportList: criminalList.results,
    //             reportList1: criminalList.results,
    //           });
    //           if (order_by && direction) {
    //             this.setState({
    //               is_sort: true,
    //             });
    //           }
    //         });
    //     });
    // } else {
    //   const data = {
    //     startDate: moment(selectedDate).format("YYYY-MM-DD"),
    //     district: user.role === "2" ? [user.districtId] : user.map_districtId,
    //     preventive_action: selectedHeadings.length > 0 ? selectedHeadings : [],
    //     search: searchText ? searchText : "",
    //     year: year.length > 0 ? year : [],
    //     order_by: order_by ? order_by : "",
    //     direction: direction ? direction : "",
    //   };
    //   notificationAction
    //     .getPreventiveActionsNotSendNotificationDistictWise(data)
    //     .then((res) => {
    //       res &&
    //         res.json().then((criminalList) => {
    //           console.log("preventive notification", criminalList);
    //           if (criminalList.results.length > 0) {
    //             this.setState({
    //               is_data: true,
    //             });
    //           }
    //           this.setState({
    //             preventiveList: criminalList.results,
    //             report1_API_loader: false,
    //             reportList: criminalList.results,
    //             reportList1: criminalList.results,
    //           });
    //           if (order_by && direction) {
    //             this.setState({
    //               is_sort: true,
    //             });
    //           }
    //         });
    //     });
    // }
  };

  getPreventiveActionsNotSendNotificationCount = () => {
    this.setState({
      report1_API_loader: true,
    });
    const {
      order_by,
      direction,
      report_1_startDate,
      report_1_endDate,
      activeRange,
      selectedDate,
    } = this.state;
    const { user } = this.props;
    let obj = {
      district:
        user.role === "9" || (user.role === "10" && user.map_districtId),
      city:
        user.role === "12"
          ? this.state.selected_city
          : user.role === "4" && user.cityId,
      order_by: order_by ? order_by : "",
      direction: direction,
      endDate:
        activeRange === "custom"
          ? moment(report_1_endDate).format("YYYY-MM-DD")
          : moment(selectedDate).format("YYYY-MM-DD"),
      rangeType: activeRange,
      startDate:
        activeRange === "custom" &&
        moment(report_1_startDate).format("YYYY-MM-DD"),
    };

    adminService.getPreventiveActionViolatorsCount(obj).then((res) => {
      res &&
        res.json().then((criminalList) => {
          console.log("preventive notification", criminalList);
          if (criminalList.data.length > 0) {
            this.setState({
              is_data: true,
            });
          }
          this.setState({
            preventiveListCount: criminalList.data,
            report1_API_loader: false,
            reportList: criminalList.data,
            report4_List_backup: criminalList.data,
          });
          if (order_by && direction) {
            this.setState({
              is_sort: true,
            });
          }
        });
    });
  };

  setPrevetiveMode = (val) => {
    this.setState({
      is_data: false,
      reportList: [],
      reportList1: [],
      preventiveListCount: [],
      report1_API_loader: false,
      preventiveList: [],
    });
    this.setState({
      // report_1_startDate: "",
      // selectedDate: "",
      reportList: [],
      showFilterSection: false,
      reportList1: [],
      preventive_action_mode: val,
    });
    if (val === "संपलेले प्रतिबंधक कारवाही") {
      this.setState({
        activeRange: "custom",
      });
    } else {
      this.setState({
        activeRange: "daily",
      });
    }
  };

  downloadReport1 = async () => {
    const { user } = this.props;
    let obj = {
      startDate: this.state.report_1_startDate,
      endDate: this.state.report_1_endDate,
      cityId: user && user.cityId,
    };
    this.setState({
      report1_loader: true,
    });

    let DocumentComponent;

    if (this.state.showList === "सांख्यिकी") {
      DocumentComponent = DocumentCount;
    } else {
      DocumentComponent = PreventiveDocument;
    }

    const blob = await pdf(
      <DocumentComponent
        columnData={this.state.preventiveAction}
        rows={this.state.reportList}
        filterDate={obj}
        total={this.state.reportList_Total}
      />,
    ).toBlob();

    if (blob) {
      this.setState({
        report1_loader: false,
      });
      saveAs(blob, "प्रतिबंधक कारवाई");
    }
  };

  download_csv = () => {
    const { preventive_action_mode, showList } = this.state;
    const { t } = this.context;
    var ReportTitle =
      preventive_action_mode === "प्रतिबंधक कारवाईचे उल्लंघन"
        ? "प्रतिबंधक कारवाईचे उल्लंघन करणाऱ्या आरोपीचे" + " - " + showList
        : preventive_action_mode + " - " + showList;
    const excludeColumns = [
      "Sr.No",
      "districtId",
      "districtName",
      "actionTakenPoliceStation",
      "सीआरपीसी कलम 110",
    ];

    const newArrayWithTotal = this.state.preventiveListCount.map(
      (item, index) => {
        const { districtId, ["सीआरपीसी कलम 110"]: _, ...restItem } = item;

        const total = Object.keys(restItem).reduce((sum, key) => {
          if (excludeColumns.includes(key) || isNaN(restItem[key])) {
            return sum;
          }
          return sum + Number(restItem[key]);
        }, 0);

        return {
          [t("पोलिस ठाणे")]: item.districtName || item.actionTakenPoliceStation,
          [t("total")]: total,
          ["बी एन एस एस १२६"]: item["बी एन एस एस १२६"],
          ["बी एन एस एस १२७"]: item["बी एन एस एस १२७"],
          ["बी एन एस एस १२८"]: item["बी एन एस एस १२८"],
          ["बी एन एस एस १२९"]: item["बी एन एस एस १२९"],
          ["मपोका कलम 68/69"]: item["मपोका कलम 68/69"],
          ["मपोका कलम 55"]: item["मपोका कलम 55"],
          ["मपोका कलम 56"]: item["मपोका कलम 56"],
          ["मपोका कलम 57"]: item["मपोका कलम 57"],
          ["मंबई दारूबंदी कायदा कलम 93"]: item["मंबई दारूबंदी कायदा कलम 93"],
          ["महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)"]:
            item["महाराष्ट्र संघटित गन्हेगारी अधधतियम (मोक्का)"],
          ["सीआरपीसी कलम 109"]: item["सीआरपीसी कलम 109"],
          ["सीआरपीसी कलम 151"]: item["सीआरपीसी कलम 151"],
          ["सीआरपीसी कलम 144 (3)"]: item["सीआरपीसी कलम 144 (3)"],
        };
      },
    );

    var title = "प्रतिबंधक_कारवाई";
    var arrData1 =
      this.state.showList == "सांख्यिकी"
        ? newArrayWithTotal
        : this.state.preventiveList;

    // Ensure it's an array

    arrData1 = Array.isArray(arrData1) ? arrData1 : [];

    const file_name = `${title}_${moment().format("DDMMMYYYY")}`;

    const filteredData = arrData1.map((data, index) => {
      const { districtName, ["Sr.No"]: _, ...filteredData } = data;
      return {
        "अ.क्र": index + 1,
        "पोलिस ठाणे": districtName,
        ...filteredData,
      };
    });

    const list =
      this.state.showList == "यादी" &&
      preventive_action_mode === "प्रतिबंधक कारवाईचे उल्लंघन"
        ? arrData1?.map((data, index) => {
            const kkInfoArray = Array.isArray(data.kk_info) ? data.kk_info : [];

            if (kkInfoArray.length === 0) return null; // Skip rows with no info

            const grouped = kkInfoArray.reduce((acc, item) => {
              const name = item?.rulesName || "-";
              const kalma = item?.kalam || "-";
              if (!acc[name]) {
                acc[name] = [kalma];
              } else if (!acc[name].includes(kalma)) {
                acc[name].push(kalma);
              }
              return acc;
            }, {});

            const groupedStr = Object.entries(grouped)
              .map(([rule, kalams]) => `${rule}: ${kalams.join(", ")}`)
              .join("; ");

            return {
              "अ.क्र": index + 1,
              "पोलिस स्टेशन(कारवाई करणारे)": data.action_taken_police_station,
              "प्रतिबंधक कारवाई": data.preventive_action_name,
              "कालावधी पासून": moment(data.date_from).format("DD/MM/YYYY"),
              "कालावधी पर्यंत": moment(data.date_to).format("DD/MM/YYYY"),
              "आरोपीचे नाव": data.name,
              "आरोपीचे पोलिस ठाणे": data.districtName,
              "गुन्ह्याचे पोलीस ठाणे": data.guna_districtName,
              "गु.र.नंबर": data.registernumber,
              "गुन्हा दाखल दिनांक": moment(data.gunha_dateTime).format(
                "DD/MM/YYYY",
              ),
              "कायदा कलम": groupedStr,
              कारण: data.reason,
            };
          })
        : this.state.showList == "यादी"
          ? arrData1?.map((data, index) => ({
              "अ.क्र": index + 1,
              "पोलिस स्टेशन(कारवाई करणारे)": data.action_taken_police_station,
              ...(preventive_action_mode ===
                "बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही" && {
                "चाप्टर केस क्रं": data?.chaptorCase,
              }),
              "प्रतिबंधक कारवाई": data.preventiveActionName,
              "कालावधी पासून": moment(data.date_from).format("DD/MM/YYYY"),
              "कालावधी पर्यंत": moment(data.date_to).format("DD/MM/YYYY"),
              "आरोपीचे नाव": data.name,
              वय: data.age,
              "आरोपीचे पोलिस ठाणे": data.districtName,
              फोटो: data.photo && data.photo ? "हो" : "नाही",
            }))
          : filteredData;

    // ✅ Remove null/undefined entries
    const arrData = (list || []).filter(Boolean);

    // ✅ Prevent crash if no data
    if (!arrData.length) {
      console.error("No data available to export.");
      return;
    }

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    // Column widths
    const columnWidths =
      this.state.showList == "यादी" &&
      preventive_action_mode === "प्रतिबंधक कारवाईचे उल्लंघन"
        ? Object.keys(arrData[0]).map((key) => ({
            wch:
              Math.max(
                key.length,
                ...arrData.map((row) => String(row[key] || "").length),
              ) + 8,
          }))
        : Object.keys(arrData[0]).map((key) => ({
            wch:
              Math.max(
                key.length,
                ...arrData.map((row) => String(row[key] || "").length),
              ) + 6,
          }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    console.log("this props.user", this.props.user);
    const cityName =
      this.props.user.role === "12"
        ? this.getCityName(this.state.selected_city)
        : this.getCityName(this.props?.user?.cityId || "");
    console.log("cityName", cityName);
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData, t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: ReportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] =
      preventive_action_mode === "बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही"
        ? {
            v: `From ${moment(this.state.report_1_startDate).format(
              "DD-MM-YYYY",
            )} - To ${moment(this.state.report_1_endDate).format(
              "DD-MM-YYYY",
            )}`,
            t: "s",
          }
        : {
            v: moment(this.state.selectedDate).format("DD-MM-YYYY"),
            t: "s",
          };

    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    const mergeRanges = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
    ];

    ws["!merges"] = mergeRanges;

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");

    XLSX.writeFile(wb, `${file_name}.xlsx`);
  };

  onFinishDateRangeGPSReport1 = (values) => {
    if (values) {
      let dates =
        values &&
        values.map((item) => {
          return item.toISOString();
        });

      this.setState({
        report_1_startDate: dates[0],
        report_1_endDate: dates[1],
      });
    }
  };

  getShowList = (value) => {
    this.setState({ showList: value });
  };

  getPreventiveInfo = () => {
    professionalAction.getPreventiveAction().then((res) => {
      res &&
        res.text().then((preventiveList) => {
          const data = [];
          preventiveList &&
            JSON.parse(preventiveList).data.forEach((item) => {
              data.push(item);
            });
          this.setState({
            preventiveAction: data,
            preventiveActionData: JSON.parse(preventiveList),
          });
        });
    });
  };

  getOngoingPreventiveActionCount = () => {
    const { selectedDate } = this.state;
    const { user } = this.props;

    this.setState({
      report1_API_loader: true,
    });
    if (["4", "12"].includes(user.role)) {
      const data = {
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        cityId: user.role === "12" ? this.state.selected_city : user.cityId,
      };
      professionalAction.getOngoingPreventiveActionCount(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveListCount: tempObj,
              report1_API_loader: false,
              reportList: list,
            });
          });
      });
    }
    if (user.role === "9" || user.role === "10") {
      const data = {
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        districtId: user?.map_districtId,
      };
      roleAction.getOngoingPreventiveActionCountByRole(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveListCount: tempObj,
              report1_API_loader: false,
              reportList: list,
            });
          });
      });
    }
  };

  getNewPreventiveActionCount = () => {
    const { selectedDate } = this.state;
    const { user } = this.props;
    this.setState({
      report1_API_loader: true,
    });
    if (["4", "12"].includes(user.role)) {
      const data = {
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        cityId: user.role === "12" ? this.state.selected_city : user.cityId,
      };
      professionalAction.getNewPreventiveActionCount(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveListCount: tempObj,
              report1_API_loader: false,
              reportList: list,
            });
          });
      });
    }
  };

  getOngoingPreventiveActionList = () => {
    const {
      selectedDate,
      preventive_action,
      selectedHeadings,
      searchText,
      order_by,
      direction,
    } = this.state;
    const { user } = this.props;
    this.setState({
      report1_API_loader: true,
    });
    console.log("selectedHeadings ongoin", selectedHeadings);
    const data = {
      startDate: moment(selectedDate).format("YYYY-MM-DD"),
      cityId: user.role === "12" ? this.state.selected_city : user.cityId,
      preventive_action: preventive_action,
      headings: selectedHeadings.length > 0 ? selectedHeadings : [],
      search: searchText ? searchText : "",
      order_by: order_by ? order_by : "",
      direction: direction,
    };
    const user_data = {
      startDate: moment(selectedDate).format("YYYY-MM-DD"),
      id: user.id,
      preventive_action: preventive_action,
      headings: selectedHeadings.length > 0 ? selectedHeadings : [],
      order_by: order_by ? order_by : "",
      direction: direction,
    };

    if (["4", "12"].includes(user.role)) {
      professionalAction.getOngoingPreventiveActionList(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveList: tempObj,
              report1_API_loader: false,
              reportList: list,
              reportList1: list,
              report4_List_backup: list,
            });
            if (order_by && direction) {
              this.setState({
                is_sort: true,
              });
            }
          });
      });
    }
    if (user.role === "2") {
      professionalAction
        .OngoingPreventiveActionListById(user_data)
        .then((res) => {
          res &&
            res.text().then((criminalList1) => {
              let criminal = JSON.parse(criminalList1);
              let list = criminal.results;
              let columns1 =
                list &&
                list &&
                list.map((itemObj, index) => {
                  return {
                    ...itemObj,
                  };
                });

              let tempObj = columns1.map((res, index) => {
                return {
                  ...res,
                };
              });
              if (tempObj.length > 0) {
                this.setState({
                  is_data: true,
                });
              }
              this.setState({
                preventiveList: tempObj,
                report1_API_loader: false,
                reportList: list,
                reportList1: list,
                report4_List_backup: list,
              });
              if (order_by && direction) {
                this.setState({
                  is_sort: true,
                });
              }
            });
        });
    }
    if (user.role === "9" || user.role === "10") {
      const data = {
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        districtId: user.map_districtId,
        preventive_action: preventive_action,
        headings: selectedHeadings.length > 0 ? selectedHeadings : [],
        search: searchText ? searchText : "",
        order_by: order_by ? order_by : "",
        direction: direction,
      };
      roleAction.OngoingPreventiveActionListByRole(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveList: tempObj,
              report1_API_loader: false,
              reportList: list,
              reportList1: list,
              report4_List_backup: list,
            });
            if (order_by && direction) {
              this.setState({
                is_sort: true,
              });
            }
          });
      });
    }
  };

  onViewAccusedForm = (data) => {
    console.log("data", data);
    if (data) {
      let obj = {
        id: data,
      };
      this.props.dispatch(professionalAction.get2PlusCriminalsViewsById(obj));
      this.showCriminalViewModel();
    }
  };
  showCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: true,
    });
  };
  closeCriminalViewModel = () => {
    this.setState({
      setCriminalViewModel: false,
    });
  };
  showGunaViewModel = () => {
    this.setState({
      showGunaDetails: true,
    });
  };
  closeGunaViewModel = () => {
    this.setState({
      showGunaDetails: false,
    });
  };

  onGunaForm = (data) => {
    if (data) {
      this.setState({ gunaLoading: true });
      this.showGunaViewModel();
      this.props.dispatch(professionalAction.getCriminalsViewsById(data));
    }
  };

  getNewPreventiveList = () => {
    const { selectedDate, preventive_action, order_by, direction } = this.state;
    const { user } = this.props;
    if (order_by && direction) {
      this.setState({ is_sort: true });
    }
    if (["4", "12"].includes(user.role)) {
      const data = {
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        cityId: user.role === "12" ? this.state.selected_city : user.cityId,
        preventive_action: preventive_action,
        order_by: order_by ? order_by : "",
        direction: direction,
      };
      professionalAction.getNewPreventiveList(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveList: tempObj,
              report1_API_loader: false,
              reportList: list,
              reportList1: list,
              report4_List_backup: list,
            });
          });
      });
    }
    if (user.role === "2") {
      const data = {
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        id: user.id,
        preventive_action: preventive_action,
        order_by: order_by ? order_by : "",
        direction: direction,
      };
      professionalAction.getNewPreventiveListById(data).then((res) => {
        res &&
          res.text().then((criminalList1) => {
            let criminal = JSON.parse(criminalList1);
            let list = criminal.results;
            let columns1 =
              list &&
              list &&
              list.map((itemObj, index) => {
                return {
                  ...itemObj,
                };
              });

            let tempObj = columns1.map((res, index) => {
              return {
                ...res,
              };
            });
            if (tempObj.length > 0) {
              this.setState({
                is_data: true,
              });
            }
            this.setState({
              preventiveList: tempObj,
              report1_API_loader: false,
              reportList: list,
              reportList1: list,
              report4_List_backup: list,
            });
          });
      });
    }
  };

  // getCompletedPreventiveActionCount = () => {
  //   const { selectedDate } = this.state;
  //   const { user } = this.props;
  //   this.setState({
  //     report1_API_loader: true,
  //   });
  //   if (user.role === "4") {
  //     const data = {
  //       startDate: moment(selectedDate).format("YYYY-MM-DD"),
  //       cityId: user.cityId,
  //     };
  //     professionalAction.getCompletedPreventiveActionCount(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveListCount: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //           });
  //         });
  //     });
  //   }
  //   if (user.role === "9" || user.role === "10") {
  //     const data = {
  //       startDate: moment(selectedDate).format("YYYY-MM-DD"),
  //       districtId: user?.map_districtId,
  //     };
  //     roleAction.getCompletedPreventiveActionCountByRole(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveListCount: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //           });
  //         });
  //     });
  //   }
  // };

  // getCompletedPreventiveActionList = () => {
  //   const { user } = this.props;
  //   const {
  //     selectedDate,
  //     preventive_action,
  //     selectedHeadings,
  //     searchText,
  //     order_by,
  //     direction,
  //   } = this.state;

  //   this.setState({
  //     report1_API_loader: true,
  //   });
  //   if (user.role === "4") {
  //     const data = {
  //       startDate: moment(selectedDate).format("YYYY-MM-DD"),
  //       cityId: user.cityId,
  //       preventive_action: preventive_action,
  //       headings: selectedHeadings.length > 0 ? selectedHeadings : [],
  //       search: searchText ? searchText : "",
  //       order_by: order_by ? order_by : "",
  //       direction: direction,
  //     };
  //     professionalAction.getCompletedPreventiveActionList(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveList: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //             reportList1: list,
  //             report4_List_backup: list,
  //           });
  //           if (order_by && direction) {
  //             this.setState({
  //               is_sort: true,
  //             });
  //           }
  //         });
  //     });
  //   }
  //   if (user.role === "2") {
  //     const data = {
  //       startDate: moment(selectedDate).format("YYYY-MM-DD"),
  //       id: user.id,
  //       preventive_action: preventive_action,
  //       headings: selectedHeadings.length > 0 ? selectedHeadings : [],
  //       search: searchText ? searchText : "",
  //       order_by: order_by ? order_by : "",
  //       direction: direction,
  //     };

  //     professionalAction.CompletedPreventiveActionListById(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveList: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //             reportList1: list,
  //             report4_List_backup: list,
  //           });
  //           if (order_by && direction) {
  //             this.setState({
  //               is_sort: true,
  //             });
  //           }
  //         });
  //     });
  //   }
  //   if (user.role === "9" || user.role === "10") {
  //     const data = {
  //       startDate: moment(selectedDate).format("YYYY-MM-DD"),
  //       districtId: user.map_districtId,
  //       preventive_action: preventive_action,
  //       headings: selectedHeadings.length > 0 ? selectedHeadings : [],
  //       search: searchText ? searchText : "",
  //       order_by: order_by ? order_by : "",
  //       direction: direction,
  //     };
  //     roleAction.CompletedPreventiveActionListByRole(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveList: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //             reportList1: list,
  //             report4_List_backup: list,
  //           });
  //           if (order_by && direction) {
  //             this.setState({
  //               is_sort: true,
  //             });
  //           }
  //         });
  //     });
  //   }
  // };

  getCompletedPreventiveActionCount = () => {
    const { selectedDate, activeRange, report_1_endDate, report_1_startDate } =
      this.state;
    const { user } = this.props;
    this.setState({
      report1_API_loader: true,
    });
    this.setState({
      report1_API_loader: true,
    });
    const data = {
      endDate:
        activeRange === "custom"
          ? moment(report_1_endDate).format("YYYY-MM-DD")
          : moment(selectedDate).format("YYYY-MM-DD"),
      cityId:
        user.role === "12"
          ? this.state.selected_city
          : user.role === "4" && user.cityId,
      districtId:
        user.role === "9" || (user.role === "10" && user.map_districtId),
      rangeType: activeRange,
      label: ["4", "12"].includes(user.role)
        ? "admin"
        : user.role === "2"
          ? "ps"
          : "officer",
      startDate:
        activeRange === "custom" &&
        moment(report_1_startDate).format("YYYY-MM-DD"),
    };
    adminService.getCompletedPreventiveActionsCount(data).then((res) => {
      let list = res.results;
      let columns1 =
        list &&
        list &&
        list.map((itemObj, index) => {
          return {
            ...itemObj,
          };
        });

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
        };
      });
      if (tempObj.length > 0) {
        this.setState({
          is_data: true,
        });
      }
      this.setState({
        preventiveListCount: tempObj,
        report1_API_loader: false,
        reportList: list,
      });
    });
  };
  getCompletedPreventiveActionList = () => {
    const { user } = this.props;
    const {
      selectedDate,
      preventive_action,
      selectedHeadings,
      searchText,
      order_by,
      direction,
      activeRange,
      report_1_startDate,
      report_1_endDate,
    } = this.state;

    this.setState({
      report1_API_loader: true,
    });
    const data = {
      endDate:
        activeRange === "custom"
          ? moment(report_1_endDate).format("YYYY-MM-DD")
          : moment(selectedDate).format("YYYY-MM-DD"),
      cityId:
        user.role === "12"
          ? this.state.selected_city
          : user.role === "4" && user.cityId,
      userId: user.role == "2" && user.id,
      districtArray:
        user.role === "9" || (user.role === "10" && user.map_districtId),
      preventive_action: preventive_action,
      headings: selectedHeadings.length > 0 ? selectedHeadings : [],
      search: searchText ? searchText : "",
      order_by: order_by ? order_by : "",
      direction: direction,
      rangeType: activeRange,
      label: ["4", "12"].includes(user.role)
        ? "admin"
        : user.role === "2"
          ? "ps"
          : "officer",
      startDate:
        activeRange === "custom" &&
        moment(report_1_startDate).format("YYYY-MM-DD"),
    };
    adminService.getCompletedPreventiveActionsList(data).then((res) => {
      let list = res.results;
      let columns1 =
        list &&
        list &&
        list.map((itemObj, index) => {
          return {
            ...itemObj,
          };
        });

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
        };
      });
      if (tempObj.length > 0) {
        this.setState({
          is_data: true,
        });
      }
      this.setState({
        preventiveList: tempObj,
        report1_API_loader: false,
        reportList: list,
        reportList1: list,
        report4_List_backup: list,
      });
      if (order_by && direction) {
        this.setState({
          is_sort: true,
        });
      }
    });
  };

  getCountData = () => {
    const { selectedDate, activeRange, report_1_endDate, report_1_startDate } =
      this.state;
    const { user } = this.props;
    this.setState({
      report1_API_loader: true,
    });
    this.setState({
      report1_API_loader: true,
    });
    const data = {
      endDate:
        activeRange === "custom"
          ? moment(report_1_endDate).format("YYYY-MM-DD")
          : moment(selectedDate).format("YYYY-MM-DD"),
      cityId:
        user.role === "12"
          ? this.state.selected_city
          : user.role === "4" && user.cityId,
      districtId:
        user.role === "9" || (user.role === "10" && user.map_districtId),
      rangeType: activeRange,
      label: ["4", "12"].includes(user.role)
        ? "admin"
        : user.role === "2"
          ? "ps"
          : "officer",
      startDate:
        activeRange === "custom" &&
        moment(report_1_startDate).format("YYYY-MM-DD"),
    };
    adminService.getPreventiveActionsCount(data).then((res) => {
      let list = res.results;
      let columns1 =
        list &&
        list &&
        list.map((itemObj, index) => {
          return {
            ...itemObj,
          };
        });

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
        };
      });
      if (tempObj.length > 0) {
        this.setState({
          is_data: true,
        });
      }
      this.setState({
        preventiveListCount: tempObj,
        report1_API_loader: false,
        reportList: list,
      });
    });
  };
  getPreventiveList = () => {
    const { user } = this.props;
    const {
      selectedDate,
      preventive_action,
      selectedHeadings,
      searchText,
      order_by,
      direction,
      activeRange,
      report_1_startDate,
      report_1_endDate,
    } = this.state;

    this.setState({
      report1_API_loader: true,
    });
    const data = {
      endDate:
        activeRange === "custom"
          ? moment(report_1_endDate).format("YYYY-MM-DD")
          : moment(selectedDate).format("YYYY-MM-DD"),
      cityId:
        user.role === "12"
          ? this.state.selected_city
          : user.role === "4" && user.cityId,
      userId: user.role == "2" && user.id,
      districtArray:
        user.role === "9" || (user.role === "10" && user.map_districtId),
      preventive_action: preventive_action,
      headings: selectedHeadings.length > 0 ? selectedHeadings : [],
      search: searchText ? searchText : "",
      order_by: order_by ? order_by : "",
      direction: direction,
      rangeType: activeRange,
      label: ["4", "12"].includes(user.role)
        ? "admin"
        : user.role === "2"
          ? "ps"
          : "officer",
      startDate:
        activeRange === "custom" &&
        moment(report_1_startDate).format("YYYY-MM-DD"),
    };
    adminService.getPreventiveActionsList(data).then((res) => {
      let list = res.results;
      let columns1 =
        list &&
        list &&
        list.map((itemObj, index) => {
          return {
            ...itemObj,
          };
        });

      let tempObj = columns1.map((res, index) => {
        return {
          ...res,
        };
      });
      if (tempObj.length > 0) {
        this.setState({
          is_data: true,
        });
      }
      this.setState({
        preventiveList: tempObj,
        report1_API_loader: false,
        reportList: list,
        reportList1: list,
        report4_List_backup: list,
      });
      if (order_by && direction) {
        this.setState({
          is_sort: true,
        });
      }
    });
  };
  getData = () => {
    this.setState({
      is_data: false,
      reportList: [],
      reportList1: [],
      preventiveListCount: [],
      // report1_API_loader: false,
    });
    const actionMap = {
      "चालु प्रतिबंधक कारवाही": {
        सांख्यिकी: this.getOngoingPreventiveActionCount,
        यादी: this.getOngoingPreventiveActionList,
      },
      "संपलेले प्रतिबंधक कारवाही": {
        सांख्यिकी: this.getCompletedPreventiveActionCount,
        यादी: this.getCompletedPreventiveActionList,
      },
      "बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही": {
        सांख्यिकी: this.getCountData,
        यादी: this.getPreventiveList,
      },
      "नव्याने केलेल्या प्रतिबंधक कारवाई": {
        सांख्यिकी: this.getNewPreventiveActionCount,
        यादी: this.getNewPreventiveList,
      },
      "प्रतिबंधक कारवाईचे उल्लंघन": {
        यादी: this.getPreventiveActionsNotSendNotification,
        सांख्यिकी: this.getPreventiveActionsNotSendNotificationCount,
      },
    };

    const { showList, preventive_action_mode } = this.state;
    const action = actionMap[preventive_action_mode]?.[showList];

    if (action) {
      action();
    } else {
      console.log("Invalid combination of showList and preventive_action_mode");
    }
  };

  // getCountData = () => {
  //   const { report_1_startDate, report_1_endDate, preventive_action } =
  //     this.state;
  //   const startDate = moment(report_1_startDate, "YYYY-MM-DD").format(
  //     "YYYY-MM-DD"
  //   );
  //   const endDate = moment(report_1_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
  //   this.setState({
  //     report1_API_loader: true,
  //   });
  //   const { user } = this.props;
  //   if (user.role === "4") {
  //     const data = {
  //       startDate: startDate,
  //       endDate: endDate,
  //       cityId: user.cityId,
  //       // preventive_action: preventive_action,
  //     };
  //     professionalAction.getPreventiveCount(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveListCount: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //           });
  //         });
  //     });
  //   }

  //   if (user.role === "9" || user.role === "10") {
  //     const data = {
  //       startDate: startDate,
  //       endDate: endDate,
  //       districtId: user?.map_districtId,
  //     };
  //     roleAction.getPreventiveCountByRole(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;
  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveListCount: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //           });
  //         });
  //     });
  //   }
  // };

  // getPreventiveList = () => {
  //   const {
  //     report_1_startDate,
  //     report_1_endDate,
  //     selectedHeadings,
  //     searchText,
  //     direction,
  //     order_by,
  //   } = this.state;
  //   const startDate = moment(report_1_startDate, "YYYY-MM-DD").format(
  //     "YYYY-MM-DD"
  //   );
  //   const endDate = moment(report_1_endDate, "YYYY-MM-DD").format("YYYY-MM-DD");
  //   const { user } = this.props;
  //   this.setState({
  //     report1_API_loader: true,
  //   });
  //   if (user.role === "4") {
  //     const data = {
  //       startDate: startDate,
  //       endDate: endDate,
  //       cityId: user.cityId,
  //       headings: selectedHeadings.length > 0 ? selectedHeadings : [],
  //       search: searchText ? searchText : "",
  //       order_by: order_by ? order_by : "",
  //       direction: direction,
  //     };

  //     professionalAction.getPreventiveList(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;

  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveList: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //             reportList1: list,
  //             report4_List_backup: list,
  //           });
  //           if (order_by && direction) {
  //             this.setState({
  //               is_sort: true,
  //             });
  //           }
  //         });
  //     });
  //   }
  //   if (user.role === "2") {
  //     const data = {
  //       startDate: startDate,
  //       endDate: endDate,
  //       id: user.id,
  //       headings: selectedHeadings.length > 0 ? selectedHeadings : [],
  //       search: searchText ? searchText : "",
  //       order_by: order_by ? order_by : "",
  //       direction: direction,
  //     };

  //     professionalAction.getPreventiveListById(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;

  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveList: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //             reportList1: list,
  //             report4_List_backup: list,
  //           });
  //           if (order_by && direction) {
  //             this.setState({
  //               is_sort: true,
  //             });
  //           }
  //         });
  //     });
  //   }
  //   if (user.role === "9" || user.role === "10") {
  //     const data = {
  //       startDate: startDate,
  //       endDate: endDate,
  //       districtId: user.map_districtId,
  //       headings: selectedHeadings.length > 0 ? selectedHeadings : [],
  //       search: searchText ? searchText : "",
  //       order_by: order_by ? order_by : "",
  //       direction: direction,
  //     };
  //     roleAction.getPreventiveListByRole(data).then((res) => {
  //       res &&
  //         res.text().then((criminalList1) => {
  //           let criminal = JSON.parse(criminalList1);
  //           let list = criminal.results;

  //           let columns1 =
  //             list &&
  //             list &&
  //             list.map((itemObj, index) => {
  //               return {
  //                 ...itemObj,
  //               };
  //             });

  //           let tempObj = columns1.map((res, index) => {
  //             return {
  //               ...res,
  //             };
  //           });
  //           if (tempObj.length > 0) {
  //             this.setState({
  //               is_data: true,
  //             });
  //           }
  //           this.setState({
  //             preventiveList: tempObj,
  //             report1_API_loader: false,
  //             reportList: list,
  //             reportList1: list,
  //             report4_List_backup: list,
  //           });
  //           if (order_by && direction) {
  //             this.setState({
  //               is_sort: true,
  //             });
  //           }
  //         });
  //     });
  //   }
  // };

  onEditAccusedForm = (data) => {
    this.setState({
      userID: data.userId,
    });
    let temo = this.props.dispatch(
      professionalAction.getCriminalsById(data.id),
    );

    temo.then((res) => {
      const { basicInfo, gunhaInfor, otherInfo } = res;
      let getEditGunhaTemp = _.filter(gunhaInfor, (o) => {
        return o.masterId === data.id;
      });
      let getEditOtherTemp = _.filter(otherInfo, (o) => {
        return o.masterId === data.id;
      });
      this.setState({
        basicInformationData: basicInfo,
        isAccusedFormEdit: [
          {
            editId: data.id,
            guhnhaEditId: getEditGunhaTemp[0] && getEditGunhaTemp[0].id,
            otherEditId: getEditOtherTemp[0] && getEditOtherTemp[0].id,
            isEdit: true,
          },
        ],
        ghunhaInfomationData: [...getEditGunhaTemp],
        otherInformationData: [...getEditOtherTemp],
        isEditForms: true,
        accusedDrawer: true,
        newGunha: false,
        resetBasicForm: false,
        newflag: 1,
      });
    });
  };

  handleDateChange = (date) => {
    this.setState({ selectedDate: date });
  };

  getCityName = (id) => {
    const { pc_cities } = this.props && this.props.professionals;
    if (pc_cities && pc_cities.length) {
      return (
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0] &&
        _.filter(pc_cities, function (o) {
          return o.id === id;
        })[0].City
      );
    }
  };

  isloading = () => {
    this.setState({ loading: true });
  };

  isNotloading = () => {
    this.setState({ loading: false });
  };

  handleDownload = () => {
    console.log("handleDownload", this.myTableRef.current);
    if (this.myTableRef.current) {
      this.myTableRef.current.handleDownloadPDF();
    }
    this.isloading();
  };

  handlePrventive = (val) => {
    this.setState({ selectedHeadings: val });
  };

  handlePrventiveFind = () => {
    if (this.state.preventive_action_mode === "चालु प्रतिबंधक कारवाही") {
      this.getOngoingPreventiveActionList();
    }
    if (this.state.preventive_action_mode === "संपलेले प्रतिबंधक कारवाही") {
      this.getCompletedPreventiveActionList();
    }
    if (
      this.state.preventive_action_mode ===
      "बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही"
    ) {
      this.getPreventiveList();
    }
    if (this.state.preventive_action_mode === "प्रतिबंधक कारवाईचे उल्लंघन") {
      this.getPreventiveActionsNotSendNotification();
    }
    this.setState({
      ispresent: true,
    });
  };
  clearFilter = () => {
    if (this.state.selectedHeadings > 0) {
      this.setState(
        {
          selectedHeadings: [],
          ispresent: false,
          reportList: [],
          reportList1: [],
          year: [],
          key: "",
          order_by: "",
          direction: "",
          is_sort: false,
        },
        () => {
          this.getData(); // Call getData after state is reset
        },
      );
    } else {
      this.setState(
        {
          selectedHeadings: [],
          searchText: "",
          ispresent: false,
          reportList: [],
          reportList1: [],
          year: [],
          key: "",
          order_by: "",
          direction: "",
          is_sort: false,
        },
        () => {
          this.getData(); // Call getData after state is reset
        },
      );
    }
  };
  clearOnlySearch = () => {
    this.setState(
      {
        reportList: [],
        reportList1: [],
      },
      () => {
        this.getData(); // Call getData after state is reset
      },
    );
  };

  handleInputChange = (e) => {
    this.setState({ searchText: e.target.value });
  };
  handleYear = (e) => {
    this.setState({
      year: e,
    });
  };
  sortPreventiveList = (name, direction, sourceList) => {
    const list =
      sourceList ||
      (this.state.reportList1?.length
        ? this.state.reportList1
        : this.state.preventiveList);

    const sortedData = [...list].sort((a, b) => {
      let x = a[name] ?? "";
      let y = b[name] ?? "";
      const isNumeric = !isNaN(x) && !isNaN(y) && x !== "" && y !== "";

      if (isNumeric) {
        x = Number(x);
        y = Number(y);
        return direction === "ASC" ? x - y : y - x;
      }

      x = x.toString().toLowerCase();
      y = y.toString().toLowerCase();
      return direction === "ASC" ? x.localeCompare(y) : y.localeCompare(x);
    });

    return sortedData;
  };

  sortby = (name, direction) => {
    const sortedData = this.sortPreventiveList(name, direction);
    this.setState({
      order_by: name,
      direction: direction,
      key: name,
      preventiveList: sortedData,
      is_sort: true,
    });
  };

  handleTableSortChange = (sortedData, sortInfo) => {
    this.setState({
      preventiveList: sortedData,
      order_by: sortInfo ? sortInfo.field : "",
      direction: sortInfo ? (sortInfo.order === "ascend" ? "ASC" : "DESC") : "",
      key: sortInfo ? sortInfo.field : "",
      is_sort: !!sortInfo,
    });
  };
  filterkey = (e) => {
    this.setState({ key: e.key });
  };

  onStartDateChange = (date) => {
    if (date) {
      const startDate = date.toISOString();

      this.setState({
        report_1_startDate: startDate,
        report_4_endDate: null,
      });
    }
  };
  onEndDateChange = (date) => {
    if (date) {
      const endDate = date.toISOString();

      this.setState({
        report_1_endDate: endDate,
      });
    }
  };

  onAnalyticsStartDateChange = (date) => {
    this.setState(
      {
        analytics_range: "custom",
        analytics_startDate: date ? date.toISOString() : "",
      },
      () => {
        if (
          this.state.showAnalytics &&
          this.state.analytics_startDate &&
          this.state.analytics_endDate
        ) {
          this.fetchPreventiveActionAnalytics();
        }
      },
    );
  };

  onAnalyticsEndDateChange = (date) => {
    this.setState(
      {
        analytics_range: "custom",
        analytics_endDate: date ? date.toISOString() : "",
      },
      () => {
        if (
          this.state.showAnalytics &&
          this.state.analytics_startDate &&
          this.state.analytics_endDate
        ) {
          this.fetchPreventiveActionAnalytics();
        }
      },
    );
  };

  setAnalyticsQuickRange = (type) => {
    if (type === "custom") {
      this.setState({ analytics_range: "custom" });
      return;
    }

    const endDate = moment().endOf("day");
    const startDate =
      type === "6month"
        ? moment().subtract(6, "months").startOf("day")
        : moment().subtract(1, "month").startOf("day");

    this.setState(
      {
        analytics_range: type,
        analytics_startDate: startDate.toISOString(),
        analytics_endDate: endDate.toISOString(),
      },
      () => {
        if (this.state.showAnalytics) {
          this.fetchPreventiveActionAnalytics();
        }
      },
    );
  };

  fetchPreventiveActionAnalytics = () => {
    const { analytics_startDate, analytics_endDate } = this.state;
    const { user } = this.props;

    if (!analytics_startDate || !analytics_endDate) {
      return;
    }

    const scope = this.getAnalyticsScope();

    if ((user.role === "4" || user.role === "12") && !scope.cityId) {
      message.warning("कृपया शहर निवडा");
      return;
    }

    if (
      (user.role === "9" || user.role === "10") &&
      (!scope.districtId || scope.districtId.length === 0)
    ) {
      message.warning("पोलिस ठाणे माहिती उपलब्ध नाही");
      return;
    }

    this.setState({ analytics_loading: true, analytics_fetched: true });
    if (user.role === "4" || user.role === "12") {
      adminService
        .getPreventiveActionAnalytics({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          ...scope,
        })
        .then((data) => {
          this.setState({
            analytics_data: data,
            analytics_loading: false,
          });
        })
        .catch((err) => {
          console.error("getPreventiveActionAnalytics error", err);
          message.error("विश्लेषण डेटा लोड करण्यात अयशस्वी");
          this.setState({ analytics_loading: false });
        });
    }
    if (user.role === "2") {
      adminService
        .getPoliceAdminPreventiveActionAnalytics({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          userid: user.id,
        })
        .then((data) => {
          this.setState({
            analytics_data: data,
            analytics_loading: false,
          });
        })
        .catch((err) => {
          console.error("getPoliceAdminPreventiveActionAnalytics error", err);
          message.error("विश्लेषण डेटा लोड करण्यात अयशस्वी");
          this.setState({ analytics_loading: false });
        });
    }
    if (user.role === "9" || user.role === "10") {
      roleAction
        .getPreventiveActionAnalyticsByRole({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          districtId: scope.districtId,
        })
        .then((data) => {
          this.setState({
            analytics_data: data,
            analytics_loading: false,
          });
        })
        .catch((err) => {
          console.error("getPreventiveActionAnalyticsByRole error", err);
          message.error("विश्लेषण डेटा लोड करण्यात अयशस्वी");
          this.setState({ analytics_loading: false });
        });
    }
  };

  getRoleDistrictIds = () => {
    const { user } = this.props;
    const raw = user?.map_districtId;

    if (Array.isArray(raw)) {
      return raw
        .filter((id) => id !== null && id !== undefined && id !== "")
        .map((id) => Number(id));
    }

    if (raw !== null && raw !== undefined && raw !== "") {
      return [Number(raw)];
    }

    return [];
  };

  getAnalyticsScope = () => {
    const { user } = this.props;

    if (user?.role === "2") {
      return { district: user.districtId };
    }
    if (user?.role === "12") {
      return { cityId: this.state.selected_city };
    }
    if (user.role === "9" || user.role === "10") {
      return { districtId: this.getRoleDistrictIds() };
    }
    return { cityId: user?.cityId };
  };

  buildAnalyticsDistrictInsights = (data, label) => {
    if (!data || data.length === 0) {
      return ["निवडलेल्या कालावधीसाठी डेटा उपलब्ध नाही."];
    }

    const insights = [];
    if (data[0]) {
      insights.push(
        `${data[0].name} मध्ये सर्वाधिक ${label} (${data[0].value}).`,
      );
    }
    if (data[1]) {
      insights.push(`${data[1].name} दुसऱ्या क्रमांकावर (${data[1].value}).`);
    }
    if (data.length > 2) {
      insights.push(`एकूण ${data.length} पो.स्टे. top 5 यादीत समाविष्ट.`);
    }
    return insights;
  };

  buildAnalyticsLowDistrictInsights = (data) => {
    if (!data || data.length === 0) {
      return ["निवडलेल्या कालावधीसाठी डेटा उपलब्ध नाही."];
    }

    const insights = [];
    if (data[0]) {
      insights.push(
        `${data[0].name} मध्ये सर्वात कमी प्रतिबंधक कारवाई (${data[0].value}).`,
      );
    }
    if (data[1]) {
      insights.push(`${data[1].name} दुसऱ्या क्रमांकावर (${data[1].value}).`);
    }
    if (data.length > 2) {
      insights.push(`एकूण ${data.length} पो.स्टे. कमी कारवाई यादीत समाविष्ट.`);
    }
    return insights;
  };

  mapAnalyticsChartData = (rows, nameKey, valueKey) =>
    (rows || []).map((item) => ({
      name: item[nameKey],
      value: Number(item[valueKey] || 0),
    }));

  mapDistrictTotalRows = (rows) =>
    (rows || []).map((item) => ({
      district: item.district,
      districtName: item.districtName || item.name,
      count: Number(item.count || 0),
    }));

  getAnalyticsDrillMode = (listType) =>
    listType &&
    (String(listType).toLowerCase().includes("bond") ||
      listType === "Bound Break")
      ? "bond"
      : "preventive";

  isPoliceAnalyticsRole = () => this.props.user?.role === "2";

  openAnalyticsDrill = ({
    listType,
    title,
    preventive_action,
    district,
    districtName,
  }) => {
    if (this.isPoliceAnalyticsRole()) {
      const policeListTypeMap = {
        district_wise_preventive_total: "Preventive_Wise",
        district_wise_bond_total: "Bound Break",
        bond_by_action: "Bound Break",
        Ongoing: "Ongoing",
        Completed: "Completed",
        twoplusCount: "twoplusCount",
      };

      return this.openDistrictAnalyticsList({
        listType: policeListTypeMap[listType] || listType,
        title,
        preventive_action,
      });
    }

    return this.openAnalyticsList({
      listType,
      title,
      preventive_action,
      district,
      districtName,
    });
  };

  onAnalyticsListPaginationChange = (page, pageSize) => {
    this.setState({
      analytics_list_page: page,
      analytics_list_page_size: pageSize,
    });
  };

  onAnalyticsListPageSizeChange = (current, size) => {
    this.setState({
      analytics_list_page: 1,
      analytics_list_page_size: size,
    });
  };

  openAnalyticsList = ({
    listType,
    title,
    preventive_action,
    district,
    districtName,
  }) => {
    const { analytics_startDate, analytics_endDate } = this.state;
    const scope = this.getAnalyticsScope();

    if (!analytics_startDate || !analytics_endDate) {
      message.warning("कृपया प्रारंभ आणि समाप्ती दिनांक निवडा");
      return;
    }

    const completedDays =
      listType === "Completed" ? 7 : this.state.analytics_completed_days;
    const completedDirection = this.state.analytics_completed_direction;

    this.setState({
      analytics_list_visible: true,
      analytics_list_loading: true,
      analytics_list_title: title,
      analytics_list_district_name: districtName || "",
      analytics_list_rows: [],
      analytics_list_type: listType,
      analytics_drill_mode: this.getAnalyticsDrillMode(listType),
      analytics_pie_loading: false,
      analytics_pie_title: "",
      analytics_pie_data: [],
      analytics_selected_district: "",
      analytics_selected_district_id: null,
      analytics_filter_preventive_action: preventive_action || null,
      analytics_filter_preventive_action_name: preventive_action ? title : "",
      analytics_completed_days: completedDays,
      analytics_completed_direction: completedDirection,
      analytics_list_page: 1,
    });

    if (listType === "bottom5_district_preventive" && !preventive_action) {
      const cachedRows = this.mapDistrictTotalRows(
        this.state.analytics_data?.bottom5_district_wise_preventive_tools,
      );

      if (cachedRows.length > 0) {
        this.setState({
          analytics_list_rows: cachedRows,
          analytics_list_loading: false,
        });
        return;
      }
    }

    if (listType === "district_wise_preventive_total" && !preventive_action) {
      const cachedRows = this.mapDistrictTotalRows(
        this.state.analytics_data?.district_wise_preventive_total,
      );

      if (cachedRows.length > 0) {
        this.setState({
          analytics_list_rows: cachedRows,
          analytics_list_loading: false,
        });
        return;
      }
    }

    if (listType === "district_wise_bond_total") {
      const cachedRows = this.mapDistrictTotalRows(
        this.state.analytics_data?.district_wise_bond_total,
      );

      if (cachedRows.length > 0) {
        this.setState({
          analytics_list_rows: cachedRows,
          analytics_list_loading: false,
        });
        return;
      }
    }

    const payload = {
      startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
      endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
      ...scope,
      listType,
    };

    if (preventive_action) {
      payload.preventive_action = preventive_action;
    }
    if (district) {
      payload.district = district;
    }

    const cityScopedListTypes = ["Ongoing", "Completed", "twoplusCount"];
    if (
      cityScopedListTypes.includes(listType) ||
      ["4", "9", "10", "12"].includes(this.props.user?.role)
    ) {
      return this.fetchAnalyticsList({
        listType,
        preventive_action,
        district,
        days: listType === "Completed" ? completedDays : undefined,
        direction: listType === "Completed" ? completedDirection : undefined,
      });
    }
  };

  getCompletedDateRangeText = (
    direction = "all",
    days = 7,
    analytics_startDate,
    analytics_endDate,
  ) => {
    if (direction === "all") {
      return analytics_startDate && analytics_endDate
        ? `${moment(analytics_startDate).format("DD/MM/YYYY")} - ${moment(
            analytics_endDate,
          ).format("DD/MM/YYYY")}`
        : "निवडलेला कालावधी";
    }

    if (direction === "past") {
      return `मागील ${days} दिवस (${moment()
        .subtract(days, "days")
        .format("DD/MM/YYYY")} - ${moment().format("DD/MM/YYYY")})`;
    }

    return `पुढील ${days} दिवस (${moment().format("DD/MM/YYYY")} - ${moment()
      .add(days, "days")
      .format("DD/MM/YYYY")})`;
  };

  fetchAnalyticsList = ({
    listType,
    preventive_action,
    district,
    days = this.state.analytics_completed_days,
    direction = this.state.analytics_completed_direction,
  }) => {
    const { analytics_startDate, analytics_endDate } = this.state;
    const scope = this.getAnalyticsScope();
    const role = this.props.user?.role;

    this.setState({
      analytics_list_loading: true,
      analytics_list_rows: [],
      analytics_list_page: 1,
    });

    const payload = {
      startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
      endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
      ...scope,
      listType,
    };

    if (preventive_action) {
      payload.preventive_action = preventive_action;
    }
    if (district) {
      payload.district = district;
    }

    if (listType === "Completed") {
      const selectedDirection =
        direction === "past"
          ? "past"
          : direction === "upcoming"
            ? "upcoming"
            : "all";
      payload.direction = selectedDirection;
      if (selectedDirection !== "all") {
        payload.days = days;
      }
    }

    if (role === "9" || role === "10") {
      return roleAction
        .getPreventiveActionAnalyticsListByRole(payload)
        .then((data) => {
          this.setState({
            analytics_list_rows: data?.results || [],
            analytics_list_loading: false,
          });
        })
        .catch((err) => {
          console.error("getPreventiveActionAnalyticsListByRole error", err);
          message.error("यादी लोड करण्यात अयशस्वी");
          this.setState({ analytics_list_loading: false });
        });
    }

    if (role === "4" || role === "12") {
      return adminService
        .getPreventiveActionAnalyticsList(payload)
        .then((data) => {
          this.setState({
            analytics_list_rows: data?.results || [],
            analytics_list_loading: false,
          });
        })
        .catch((err) => {
          console.error("getPreventiveActionAnalyticsList error", err);
          message.error("यादी लोड करण्यात अयशस्वी");
          this.setState({ analytics_list_loading: false });
        });
    }

    return Promise.resolve();
  };

  fetchDistrictAnalyticsList = ({
    listType,
    preventive_action,
    days = this.state.analytics_completed_days,
    direction = this.state.analytics_completed_direction,
  }) => {
    const { user } = this.props;
    const { analytics_startDate, analytics_endDate } = this.state;

    this.setState({
      analytics_list_loading: true,
      analytics_list_rows: [],
      analytics_list_page: 1,
    });

    const payload = {
      label: listType,
      startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
      endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
      userid: user.id,
      preventive_action,
    };

    if (listType === "Completed") {
      const selectedDirection =
        direction === "past"
          ? "past"
          : direction === "upcoming"
            ? "upcoming"
            : "all";
      payload.direction = selectedDirection;
      if (selectedDirection !== "all") {
        payload.days = days;
      }
    }

    return adminService
      .getDistrictPreventiveActionAnalyticsList(payload)
      .then((res) => {
        this.setState({
          analytics_list_rows: res.results || [],
          analytics_list_loading: false,
        });
      })
      .catch((err) => {
        console.error("district analytics list error", err);
        message.error("यादी लोड करण्यात अयशस्वी");
        this.setState({ analytics_list_loading: false });
      });
  };

  openDistrictAnalyticsList = ({ listType, title, preventive_action }) => {
    const completedDays =
      listType === "Completed" ? 7 : this.state.analytics_completed_days;
    const completedDirection = this.state.analytics_completed_direction;

    this.setState({
      analytics_list_visible: true,
      analytics_list_loading: true,
      analytics_list_title: title,
      analytics_list_rows: [],
      analytics_list_type: listType,
      analytics_drill_mode: this.getAnalyticsDrillMode(listType),
      analytics_pie_loading: false,
      analytics_pie_title: "",
      analytics_pie_data: [],
      analytics_selected_district: "",
      analytics_selected_district_id: null,
      analytics_completed_days: completedDays,
      analytics_completed_direction: completedDirection,
      analytics_list_page: 1,
    });

    this.fetchDistrictAnalyticsList({
      listType,
      preventive_action,
      days: completedDays,
      direction: completedDirection,
    });
  };

  onCompletedDirectionFilterChange = (direction) => {
    const { analytics_list_type } = this.state;
    if (analytics_list_type !== "Completed") {
      return;
    }

    const selectedDirection =
      direction === "past"
        ? "past"
        : direction === "upcoming"
          ? "upcoming"
          : "all";

    this.setState({ analytics_completed_direction: selectedDirection }, () => {
      if (["4", "9", "10", "12"].includes(this.props.user?.role)) {
        this.fetchAnalyticsList({
          listType: "Completed",
          direction: selectedDirection,
          days: this.state.analytics_completed_days,
        });
        return;
      }

      this.fetchDistrictAnalyticsList({
        listType: "Completed",
        direction: selectedDirection,
        days: this.state.analytics_completed_days,
      });
    });
  };

  onCompletedDaysFilterChange = (days) => {
    const { analytics_list_type } = this.state;
    if (analytics_list_type !== "Completed") {
      return;
    }

    const selectedDays = Number(days);
    if (![7, 15, 30].includes(selectedDays)) {
      return;
    }

    this.setState({ analytics_completed_days: selectedDays }, () => {
      if (
        this.props.user?.role === "4" ||
        this.props.user.role === "9" ||
        this.props.user.role === "10" ||
        this.props.user.role === "12"
      ) {
        this.fetchAnalyticsList({
          listType: "Completed",
          days: selectedDays,
          direction: this.state.analytics_completed_direction,
        });
        return;
      }

      this.fetchDistrictAnalyticsList({
        listType: "Completed",
        days: selectedDays,
        direction: this.state.analytics_completed_direction,
      });
    });
  };

  closeAnalyticsList = () => {
    this.setState({
      analytics_list_visible: false,
      analytics_list_rows: [],
      analytics_list_title: "",
      analytics_list_district_name: "",
      analytics_list_type: "",
      analytics_drill_mode: "preventive",
      analytics_pie_loading: false,
      analytics_pie_title: "",
      analytics_pie_data: [],
      analytics_selected_district: "",
      analytics_selected_district_id: null,
      analytics_filter_preventive_action: null,
      analytics_filter_preventive_action_name: "",
      analytics_completed_days: 7,
      analytics_completed_direction: "upcoming",
      analytics_list_page: 1,
      analytics_list_page_size: 10,
    });
  };

  loadAnalyticsAccusedList = ({
    district,
    districtName,
    preventive_action,
    title,
    isBond = false,
  }) => {
    const { analytics_startDate, analytics_endDate } = this.state;
    const scope = this.getAnalyticsScope();
    const listType = isBond ? "bond_by_action" : "preventive_by_action";

    this.setState({
      analytics_list_type: listType,
      analytics_list_loading: true,
      analytics_list_title: title,
      analytics_list_district_name: districtName || "",
      analytics_list_rows: [],
      analytics_list_page: 1,
      analytics_pie_loading: false,
      analytics_pie_title: "",
      analytics_pie_data: [],
      analytics_selected_district: "",
      analytics_selected_district_id: null,
    });

    if (this.props.user.role === "4" || this.props.user.role === "12") {
      adminService
        .getPreventiveActionAnalyticsList({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          ...scope,
          listType,
          preventive_action,
          district,
        })
        .then((data) => {
          this.setState({
            analytics_list_rows: data?.results || [],
            analytics_list_loading: false,
          });
        })
        .catch((err) => {
          console.error("preventive_by_action list error", err);
          message.error("यादी लोड करण्यात अयशस्वी");
          this.setState({ analytics_list_loading: false });
        });
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      roleAction
        .getPreventiveActionAnalyticsListByRole({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          ...scope,
          listType,
          preventive_action,
          district,
        })
        .then((data) => {
          this.setState({
            analytics_list_rows: data?.results || [],
            analytics_list_loading: false,
          });
        })
        .catch((err) => {
          console.error("preventive_by_action list error", err);
          message.error("यादी लोड करण्यात अयशस्वी");
          this.setState({ analytics_list_loading: false });
        });
    }
  };

  openAnalyticsDistrictDrillDown = ({ district, districtName, count }) => {
    const {
      analytics_startDate,
      analytics_endDate,
      analytics_drill_mode,
      analytics_filter_preventive_action,
      analytics_filter_preventive_action_name,
    } = this.state;
    const scope = this.getAnalyticsScope();
    const isBond = analytics_drill_mode === "bond";

    if (!analytics_startDate || !analytics_endDate) {
      message.warning("कृपया प्रारंभ आणि समाप्ती दिनांक निवडा");
      return;
    }

    if (!Number(count)) {
      message.info(
        isBond
          ? "या पो. स्टेसाठी Bond Breaker नोंद नाही"
          : "या पो. स्टेसाठी प्रतिबंधक कारवाई नोंद नाही",
      );
      return;
    }

    if (!isBond && analytics_filter_preventive_action) {
      this.loadAnalyticsAccusedList({
        district,
        districtName,
        preventive_action: analytics_filter_preventive_action,
        title: `${analytics_filter_preventive_action_name || "प्रतिबंधक कारवाई"} - ${districtName}`,
        isBond: false,
      });
      return;
    }

    this.setState({
      analytics_selected_district: districtName,
      analytics_selected_district_id: district,
      analytics_pie_loading: true,
      analytics_pie_title: `${districtName} - ${
        isBond ? "Bond Breaker" : "प्रतिबंधक कारवाई"
      } निहाय`,
      analytics_pie_data: [],
    });
    if (this.props.user.role === "4" || this.props.user.role === "12") {
      adminService
        .getPreventiveActionAnalyticsList({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          ...scope,
          listType: isBond
            ? "district_bond_action_wise"
            : "district_preventive_action_wise",
          district,
        })
        .then((data) => {
          const detailData = (data?.results || []).map((item) => ({
            name: item.preventive_action_name,
            value: Number(item.count || 0),
            preventive_action: item.preventive_action,
          }));
          this.setState({
            analytics_pie_data: detailData,
            analytics_pie_loading: false,
          });
        })
        .catch((err) => {
          console.error("district drill-down error", err);
          message.error("तपशील लोड करण्यात अयशस्वी");
          this.setState({ analytics_pie_loading: false });
        });
    }
    if (this.props.user.role === "9" || this.props.user.role === "10") {
      roleAction
        .getPreventiveActionAnalyticsListByRole({
          startDate: moment(analytics_startDate).format("YYYY-MM-DD"),
          endDate: moment(analytics_endDate).format("YYYY-MM-DD"),
          ...scope,
          listType: isBond
            ? "district_bond_action_wise"
            : "district_preventive_action_wise",
          district,
        })
        .then((data) => {
          const detailData = (data?.results || []).map((item) => ({
            name: item.preventive_action_name,
            value: Number(item.count || 0),
            preventive_action: item.preventive_action,
          }));
          this.setState({
            analytics_pie_data: detailData,
            analytics_pie_loading: false,
          });
        })
        .catch((err) => {
          console.error("district drill-down error", err);
          message.error("तपशील लोड करण्यात अयशस्वी");
          this.setState({ analytics_pie_loading: false });
        });
    }
  };

  renderAnalyticsDistrictChartView = (rows) => {
    const {
      analytics_drill_mode,
      analytics_pie_title,
      analytics_pie_loading,
      analytics_pie_data,
      analytics_selected_district,
      analytics_selected_district_id,
      analytics_filter_preventive_action,
    } = this.state;
    const isBond = analytics_drill_mode === "bond";
    const isActionFiltered = !isBond && !!analytics_filter_preventive_action;
    const barData = this.mapDistrictTotalRows(rows).map((item) => ({
      name: item.districtName,
      value: item.count,
      district: item.district,
    }));
    const hasPieSection = !!(analytics_pie_title || analytics_pie_loading);
    const pieTotal = analytics_pie_data.reduce(
      (sum, item) => sum + item.value,
      0,
    );

    if (!barData.length) {
      return this.renderAnalyticsEmptyChart();
    }
    const { t } = this.context;

    return (
      <div>
        <div
          style={{
            fontSize: 13,
            color: "#8c8c8c",
            marginBottom: 12,
          }}
        >
          {isActionFiltered
            ? t("clickPoliceStationToViewList")
            : t("clickPoliceStationForPieChart")}
        </div>

        <div
          style={{
            maxHeight: hasPieSection ? "38vh" : "65vh",
            overflowY: "auto",
            paddingRight: 8,
            marginBottom: hasPieSection ? 16 : 0,
          }}
        >
          {barData.map((item) => {
            const maxValue = Math.max(...barData.map((d) => d.value), 1);
            const isSelected = analytics_selected_district === item.name;
            const trackColor = isBond ? "#fff7e6" : "#e6f4ff";
            const fillGradient = isBond
              ? "linear-gradient(90deg, #fa8c16 0%, #ffc069 100%)"
              : "linear-gradient(90deg, #1890ff 0%, #69b1ff 100%)";

            return (
              <div
                key={item.district}
                style={{
                  marginBottom: 14,
                  padding: isSelected ? "8px 10px" : "4px 6px",
                  borderRadius: 8,
                  border: isSelected
                    ? `2px solid ${isBond ? "#fa8c16" : "#1890ff"}`
                    : "2px solid transparent",
                  background: isSelected ? "#fafafa" : "transparent",
                  cursor: "pointer",
                }}
                onClick={() =>
                  this.openAnalyticsDistrictDrillDown({
                    district: item.district,
                    districtName: item.name,
                    count: item.value,
                  })
                }
              >
                <div
                  style={{
                    fontSize: 13,
                    color: "#595959",
                    marginBottom: 6,
                    fontWeight: isSelected ? 600 : 500,
                  }}
                >
                  {item.name}
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <div
                    style={{
                      flex: 1,
                      height: 16,
                      background: trackColor,
                      borderRadius: 8,
                      overflow: "hidden",
                    }}
                  >
                    <div
                      style={{
                        width: `${(item.value / maxValue) * 100}%`,
                        height: "100%",
                        background: fillGradient,
                        borderRadius: 8,
                      }}
                    />
                  </div>
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: 14,
                      color: isBond ? "#fa8c16" : "#1677ff",
                      minWidth: 32,
                      textAlign: "right",
                    }}
                  >
                    {item.value}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        {hasPieSection && (
          <div
            style={{
              borderTop: "1px solid #f0f0f0",
              paddingTop: 16,
            }}
          >
            <div
              style={{
                fontSize: 14,
                fontWeight: 600,
                color: "#262626",
                marginBottom: 12,
              }}
            >
              {analytics_pie_title}
            </div>
            <Spin spinning={analytics_pie_loading}>
              {analytics_pie_data.length > 0 ? (
                <div
                  style={{
                    display: "flex",
                    gap: 16,
                    alignItems: "center",
                    flexWrap: "wrap",
                    minHeight: 300,
                  }}
                >
                  <div style={{ width: "100%", maxWidth: 360, height: 300 }}>
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={analytics_pie_data}
                          dataKey="value"
                          nameKey="name"
                          cx="50%"
                          cy="50%"
                          innerRadius={60}
                          outerRadius={105}
                          paddingAngle={2}
                          onClick={(entry) => {
                            if (!analytics_selected_district_id) return;
                            const pieEntry = entry?.payload || entry;
                            this.loadAnalyticsAccusedList({
                              district: analytics_selected_district_id,
                              districtName: analytics_selected_district,
                              preventive_action: pieEntry.preventive_action,
                              title: `${pieEntry.name} - ${analytics_selected_district}`,
                              isBond,
                            });
                          }}
                        >
                          {analytics_pie_data.map((entry, idx) => (
                            <Cell
                              key={`${entry.name}-${idx}`}
                              fill={
                                ANALYTICS_PIE_COLORS[
                                  idx % ANALYTICS_PIE_COLORS.length
                                ]
                              }
                              stroke="#fff"
                              strokeWidth={2}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                  {this.renderAnalyticsPieLegend(
                    analytics_pie_data,
                    analytics_selected_district_id
                      ? (item) =>
                          this.loadAnalyticsAccusedList({
                            district: analytics_selected_district_id,
                            districtName: analytics_selected_district,
                            preventive_action: item.preventive_action,
                            title: `${item.name} - ${analytics_selected_district}`,
                            isBond,
                          })
                      : null,
                    pieTotal,
                  )}
                </div>
              ) : (
                !analytics_pie_loading && this.renderAnalyticsEmptyChart()
              )}
            </Spin>
          </div>
        )}
      </div>
    );
  };

  getAnalyticsDaysLeftText = (dateTo) => {
    if (!dateTo) return "-";
    const today = new Date();
    const endDate = new Date(dateTo);
    today.setHours(0, 0, 0, 0);
    endDate.setHours(0, 0, 0, 0);
    const diffDays = Math.ceil((endDate - today) / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? `${diffDays} Days` : "Expired";
  };

  writeStyledPreventiveExcel = ({
    arrData,
    reportTitle,
    dateText,
    fileName,
  }) => {
    const ws = XLSX.utils.json_to_sheet(arrData, { origin: "A4" });

    const columnWidths = Object.keys(arrData[0]).map((key) => ({
      wch:
        Math.max(
          key.length,
          ...arrData.map((row) => String(row[key] || "").length),
        ) + 6,
    }));

    ws["!cols"] = columnWidths;

    const titleStyle = {
      font: { bold: true, sz: 16, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const subTitleStyle = {
      font: { bold: true, sz: 12, color: { rgb: "1F4E78" } },
      alignment: { horizontal: "center", vertical: "center" },
    };

    const headerStyle = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "305496" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    const cellStyle = {
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
      border: {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      },
    };

    Object.keys(arrData[0]).forEach((_, colIndex) => {
      const cellRef = XLSX.utils.encode_cell({ r: 3, c: colIndex });
      if (ws[cellRef]) {
        ws[cellRef].s = headerStyle;
      }
    });

    arrData.forEach((row, rowIndex) => {
      Object.values(row).forEach((_, colIndex) => {
        const cellRef = XLSX.utils.encode_cell({
          r: rowIndex + 4,
          c: colIndex,
        });
        if (ws[cellRef]) {
          ws[cellRef].s = cellStyle;
        }
      });
    });

    const cityName =
      this.props.user.role === "12"
        ? this.getCityName(this.state.selected_city)
        : this.getCityName(this.props?.user?.cityId || "");
    const stateName =
      this.props?.user?.role === "2" && this.state.district_name;
    const headerData =
      this.props?.user?.role === "2"
        ? `${stateName} (${cityName})`
        : `${cityName}`;

    ws["A1"] = { v: headerData || "", t: "s" };
    ws["A1"].s = titleStyle;

    ws["A2"] = { v: reportTitle, t: "s" };
    ws["A2"].s = subTitleStyle;

    ws["A3"] = { v: dateText || "", t: "s" };
    ws["A3"].s = subTitleStyle;

    const footerContent = `Generated At ${moment(new Date()).format(
      "DD MMM YYYY",
    )} From Criminal Monitoring Intelligent System`;

    const footerRowIndex = arrData.length + 6;

    XLSX.utils.sheet_add_aoa(ws, [[footerContent]], {
      origin: `A${footerRowIndex}`,
    });
    ws[`A${footerRowIndex}`].s = {
      font: { italic: true, sz: 11, color: { rgb: "555555" } },
      alignment: { horizontal: "center", vertical: "center", wrapText: true },
    };

    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: columnWidths.length - 1 } },
      { s: { r: 1, c: 0 }, e: { r: 1, c: columnWidths.length - 1 } },
      { s: { r: 2, c: 0 }, e: { r: 2, c: columnWidths.length - 1 } },
      {
        s: { r: footerRowIndex - 1, c: 0 },
        e: { r: footerRowIndex - 1, c: columnWidths.length - 1 },
      },
    ];

    ws["!rows"] = Array(footerRowIndex).fill({ hpt: 25 });
    ws["!rows"][footerRowIndex - 1] = { hpt: 40 };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Report");
    XLSX.writeFile(wb, `${fileName}.xlsx`);
  };

  downloadAnalyticsListExcel = () => {
    const { t } = this.context;
    const {
      analytics_list_title,
      analytics_list_district_name,
      analytics_list_rows,
      analytics_list_type,
      analytics_startDate,
      analytics_endDate,
      analytics_completed_days,
      analytics_completed_direction,
    } = this.state;
    const { user } = this.props;
    const rows = Array.isArray(analytics_list_rows) ? analytics_list_rows : [];

    if (!rows.length) {
      message.warning("No data available to export.");
      return;
    }

    const isDistrictCountList = [
      "bottom5_district_preventive",
      "district_wise_preventive_total",
      "district_wise_bond_total",
    ].includes(analytics_list_type);
    const isCompletedList = analytics_list_type === "Completed";
    const reportTitle = analytics_list_district_name
      ? `${analytics_list_title || "यादी"} - पो. स्टे: ${analytics_list_district_name}`
      : analytics_list_title || "यादी";

    const dateText = isCompletedList
      ? this.getCompletedDateRangeText(
          analytics_completed_direction,
          analytics_completed_days,
          analytics_startDate,
          analytics_endDate,
        )
      : analytics_startDate && analytics_endDate
        ? `From ${moment(analytics_startDate).format("DD-MM-YYYY")} - To ${moment(
            analytics_endDate,
          ).format("DD-MM-YYYY")}`
        : "";

    let arrData;
    if (isDistrictCountList) {
      arrData = this.mapDistrictTotalRows(rows).map((item, index) => ({
        [t("sr.no")]: index + 1,
        [t("police_stations")]: item.districtName || "-",
        [t("total")]: item.count,
      }));
    } else if (analytics_list_type === "twoplusCount") {
      arrData = rows.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("accused_name")]: data.name || "-",
        [t("police_stations")]:
          data.districtName || analytics_list_district_name || "-",
        [t("cr.no")]: data.cr_no || "-",
        [t("crime_registration_date")]: data.guna_date || "-",
        [t("total_crimes")]: data.totalCrimeCount
          ? data.totalCrimeCount
          : data.count,
      }));
    } else if (
      ["4", "9", "10"].includes(user.role) &&
      !["Ongoing", "Completed"].includes(analytics_list_type)
    ) {
      arrData = rows.map((data, index) => ({
        [t("sr.no")]: index + 1,
        [t("action_taken_police_station")]:
          data.action_taken_police_station || "-",
        [t("preventive_action")]: data.preventive_action_name || "-",
        [t("police_stations")]:
          data.districtName || analytics_list_district_name || "-",
        [t("accused_name")]: data.name || "-",
        [t("total_crimes")]: data.totalCrimeCount
          ? data.totalCrimeCount
          : data.count,
      }));
    } else {
      arrData = rows.map((data, index) => {
        const row = {
          [t("sr.no")]: index + 1,
          [t("action_taken_police_station")]:
            data.action_taken_police_station || "-",
          [t("preventive_action")]: data.preventive_action_name || "-",
          [t("police_stations")]:
            data.districtName || analytics_list_district_name || "-",
          [t("accused_name")]: data.name || "-",
          [t("total_crimes")]: data.totalCrimeCount
            ? data.totalCrimeCount
            : data.count,
          [t("date_from")]: data.date_from
            ? moment(data.date_from).format("DD-MM-YYYY")
            : "-",
          [t("date_to")]: data.date_to
            ? moment(data.date_to).format("DD-MM-YYYY")
            : "-",
        };
        if (analytics_list_title === "चालु प्रतिबंधक कारवाई") {
          row["शिल्लक दिवस"] = this.getAnalyticsDaysLeftText(data.date_to);
        }
        return row;
      });
    }

    const fileName = `${String(reportTitle)
      .replace(/[\\/:*?"<>|]/g, "_")
      .replace(/\s+/g, "_")}_${moment().format("DDMMMYYYY")}`;

    this.writeStyledPreventiveExcel({
      arrData,
      reportTitle,
      dateText,
      fileName,
    });
  };

  renderAnalyticsListModal = () => {
    const {
      analytics_list_visible,
      analytics_list_loading,
      analytics_list_title,
      analytics_list_district_name,
      analytics_list_rows,
      analytics_list_type,
      analytics_list_page,
      analytics_list_page_size,
      analytics_startDate,
      analytics_endDate,
      analytics_completed_days,
      analytics_completed_direction,
    } = this.state;

    const { user } = this.props;
    const isDistrictCountList = [
      "bottom5_district_preventive",
      "district_wise_preventive_total",
      "district_wise_bond_total",
    ].includes(analytics_list_type);
    const isCompletedList = analytics_list_type === "Completed";

    const dateRangeText = isCompletedList
      ? this.getCompletedDateRangeText(
          analytics_completed_direction,
          analytics_completed_days,
          analytics_startDate,
          analytics_endDate,
        )
      : analytics_startDate && analytics_endDate
        ? `${moment(analytics_startDate).format("DD/MM/YYYY")} - ${moment(analytics_endDate).format("DD/MM/YYYY")}`
        : "";
    const { t } = this.context;
    const getAnalyticsListSrNo = (index) =>
      (analytics_list_page - 1) * analytics_list_page_size + index + 1;
    console.log("analytics_list_type", analytics_list_type);
    let columns;
    if (analytics_list_type === "twoplusCount") {
      columns = [
        {
          title: "अ.क्र.",
          key: "sr_no",
          width: 70,
          render: (_, __, index) => getAnalyticsListSrNo(index),
        },
        {
          title: t("accused_name"),
          dataIndex: "name",
          key: "name",
          sorter: {
            compare: (a, b) => a.name.localeCompare(b.name),
            multiple: 1,
          },
        },
        {
          title: t("police_stations"),
          dataIndex: "districtName",
          key: "districtName",
          sorter: {
            compare: (a, b) => a.districtName.localeCompare(b.districtName),
            multiple: 1,
          },
          render: (districtName) =>
            districtName || analytics_list_district_name || "-",
        },
        {
          title: t("cr.no"),
          dataIndex: "cr_no",
          key: "cr_no",
          sorter: {
            compare: (a, b) => a.cr_no - b.cr_no,
            multiple: 1,
          },
          render: (cr_no) => cr_no || "-",
        },
        {
          title: t("crime_registration_date"),
          dataIndex: "guna_date",
          key: "guna_date",
          sorter: {
            compare: (a, b) => a.guna_date - b.guna_date,
            multiple: 1,
          },
          render: (guna_date) => guna_date || "-",
        },
        {
          title: t("total_crimes"),
          dataIndex: "totalCrimeCount",
          key: "totalCrimeCount",
          width: 120,
          sorter: {
            compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
            multiple: 1,
          },
          render: (text, record) => (
            <div>
              <Button
                type="primary"
                shape="circle"
                size="small"
                style={{
                  width: 36,
                  height: 36,
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
                onClick={() => {
                  this.onGunaForm(record.id);
                }}
              >
                {record.totalCrimeCount
                  ? record.totalCrimeCount
                  : record.count
                    ? record.count
                    : "0"}
              </Button>
            </div>
          ),
        },
        {
          title: t("action"),
          key: "action",
          width: 120,
          render: (_, record) => (
            <Button
              type="link"
              size="small"
              onClick={() => this.onViewAccusedForm(record.id)}
            >
              {t("view1")}
            </Button>
          ),
        },
      ];
    } else if (
      ["4", "9", "10"].includes(user.role) &&
      !["Ongoing", "Completed"].includes(analytics_list_type)
    ) {
      columns = [
        {
          title: t("sr.no"),
          key: "sr_no",
          width: 70,
          render: (_, __, index) => getAnalyticsListSrNo(index),
        },
        {
          title: t("action_taken_police_station"),
          dataIndex: "action_taken_police_station",
          key: "action_taken_police_station",
          width: 220,
          ellipsis: true,
          render: (action_taken_police_station) =>
            action_taken_police_station || "-",
        },
        {
          title: t("preventive_action"),
          dataIndex: "preventive_action_name",
          key: "preventive_action_name",
          width: 200,
          ellipsis: true,
        },
        {
          title: t("police_stations"),
          dataIndex: "districtName",
          key: "districtName",
          width: 200,
          ellipsis: true,
          sorter: {
            compare: (a, b) => a.districtName.localeCompare(b.districtName),
            multiple: 1,
          },
          render: (districtName) =>
            districtName || analytics_list_district_name || "-",
        },

        {
          title: t("accused_name"),
          dataIndex: "name",
          width: 180,
          ellipsis: true,
          sorter: {
            compare: (a, b) => a.name.localeCompare(b.name),
            multiple: 1,
          },
          key: "name",
        },
        {
          title: t("total_crimes"),
          dataIndex: "totalCrimeCount",
          key: "totalCrimeCount",
          sorter: {
            compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
            multiple: 1,
          },
          width: 120,
          render: (text, record) => (
            <div>
              <Button
                type="primary"
                shape="circle"
                size="small"
                style={{
                  width: 36,
                  height: 36,
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
                onClick={() => {
                  this.onGunaForm(record.id);
                }}
              >
                {record.totalCrimeCount
                  ? record.totalCrimeCount
                  : record.count
                    ? record.count
                    : "0"}
              </Button>
            </div>
          ),
        },
        {
          title: t("action"),
          key: "action",
          width: 120,
          render: (_, record) => (
            <Button
              type="link"
              size="small"
              onClick={() => this.onViewAccusedForm(record.id)}
            >
              {t("view1")}
            </Button>
          ),
        },
      ];
    } else {
      columns = [
        {
          title: t("sr.no"),
          key: "sr_no",
          width: 70,
          render: (_, __, index) => getAnalyticsListSrNo(index),
        },
        {
          title: t("action_taken_police_station"),
          dataIndex: "action_taken_police_station",
          key: "action_taken_police_station",
          width: 220,
          ellipsis: true,
          render: (action_taken_police_station) =>
            action_taken_police_station || "-",
        },
        {
          title: t("preventive_action"),
          dataIndex: "preventive_action_name",
          key: "preventive_action_name",
          width: 200,
          ellipsis: true,
        },
        {
          title: t("police_stations"),
          dataIndex: "districtName",
          key: "districtName",
          width: 200,
          ellipsis: true,
          sorter: {
            compare: (a, b) => a.districtName.localeCompare(b.districtName),
            multiple: 1,
          },
          render: (districtName) =>
            districtName || analytics_list_district_name || "-",
        },

        {
          title: t("accused_name"),
          dataIndex: "name",
          width: 180,
          ellipsis: true,
          sorter: {
            compare: (a, b) => a.name.localeCompare(b.name),
            multiple: 1,
          },
          key: "name",
        },
        {
          title: t("total_crimes"),
          dataIndex: "totalCrimeCount",
          key: "totalCrimeCount",
          sorter: {
            compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
            multiple: 1,
          },
          width: 120,
          render: (text, record) => (
            <div>
              <Button
                type="primary"
                shape="circle"
                size="small"
                style={{
                  width: 36,
                  height: 36,
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
                onClick={() => {
                  this.onGunaForm(record.id);
                }}
              >
                {record.totalCrimeCount
                  ? record.totalCrimeCount
                  : record.count
                    ? record.count
                    : "0"}
              </Button>
            </div>
          ),
        },
        {
          title: t("date_from"),
          dataIndex: "date_from",
          key: "date_from",
          width: 130,
          render: (value, record) =>
            moment(record.date_from).format("DD-MM-YYYY"),
        },
        {
          title: t("date_to"),
          dataIndex: "date_to",
          key: "date_to",
          width: 130,
          render: (value, record) =>
            moment(record.date_to).format("DD-MM-YYYY"),
        },
        {
          title: t("actiom"),
          key: "profile",
          width: 120,
          render: (_, record) => (
            <Button
              type="link"
              size="small"
              onClick={() => this.onViewAccusedForm(record.id)}
            >
              View
            </Button>
          ),
        },
      ];
    }
    if (analytics_list_type === "bond_by_action") {
      columns = [
        {
          title: t("sr.no"),
          key: "sr_no",
          width: 70,
          render: (_, __, index) => getAnalyticsListSrNo(index),
        },
        {
          title: t("action_taken_police_station"),
          dataIndex: "action_taken_police_station",
          key: "action_taken_police_station",
          width: 220,
          ellipsis: true,
          onHeaderCell: () => ({
            style: {
              backgroundColor: "#ffcc80",
              color: "#000",
              fontWeight: "bold",
            },
          }),
          onCell: () => ({
            style: {
              backgroundColor: "#ffcc80",
              color: "#000",
            },
          }),
          render: (action_taken_police_station) =>
            action_taken_police_station || "-",
        },
        {
          title: t("preventive_action"),
          dataIndex: "preventive_action_name",
          key: "preventive_action_name",
          width: 200,
          ellipsis: true,
        },
        {
          title: t("date_from"),
          dataIndex: "date_from",
          key: "date_from",
          width: 130,
          render: (value, record) =>
            moment(record.date_from).format("DD-MM-YYYY"),
        },
        {
          title: t("date_to"),
          dataIndex: "date_to",
          key: "date_to",
          width: 130,
          render: (value, record) =>
            moment(record.date_to).format("DD-MM-YYYY"),
        },
        {
          title: t("accused_name"),
          dataIndex: "name",
          width: 180,
          ellipsis: true,
          sorter: {
            compare: (a, b) => a.name.localeCompare(b.name),
            multiple: 1,
          },
          key: "name",
          render: (_, record) => (
            <Button
              type="link"
              size="small"
              onClick={() => this.onViewAccusedForm(record.id)}
            >
              {record.name}
            </Button>
          ),
        },
        {
          title: t("total_crimes"),
          dataIndex: "totalCrimeCount",
          key: "totalCrimeCount",
          sorter: {
            compare: (a, b) => a.totalCrimeCount - b.totalCrimeCount,
            multiple: 1,
          },
          width: 120,
          render: (text, record) => (
            <div>
              <Button
                type="primary"
                shape="circle"
                size="small"
                style={{
                  width: 36,
                  height: 36,
                  fontWeight: 600,
                  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                }}
                onClick={() => {
                  this.onGunaForm(record.id);
                }}
              >
                {record.totalCrimeCount
                  ? record.totalCrimeCount
                  : record.count
                    ? record.count
                    : "0"}
              </Button>
            </div>
          ),
        },
        {
          title: t("crime_register_number"),
          key: "registernumber",
          dataIndex: "registernumber",
          sorter: {
            compare: (a, b) => a.registernumber - b.registernumber,
          },
          render: (text, record) => (
            <>
              <p>{record?.registernumber}</p>
              <p>{moment(record?.gunha_dateTime).format("DD/MM/YYYY")}</p>
              <p>{record?.districtName}</p>
            </>
          ),
        },
      ];
    }
    if (analytics_list_title === "चालु प्रतिबंधक कारवाई") {
      const dateToIndex = columns.findIndex(
        (col) => col.dataIndex === "date_to",
      );

      const daysLeftColumn = {
        title: "शिल्लक दिवस",
        key: "daysLeft",
        width: 120,
        render: (_, record) => {
          const today = new Date();
          const endDate = new Date(record.date_to);

          today.setHours(0, 0, 0, 0);
          endDate.setHours(0, 0, 0, 0);

          const diffTime = endDate - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

          return diffDays > 0 ? `${diffDays} Days` : "Expired";
        },
      };

      if (dateToIndex !== -1) {
        columns.splice(dateToIndex + 1, 0, daysLeftColumn);
      } else {
        columns.push(daysLeftColumn);
      }
    }
    const drawerTitle = (
      <div style={{ width: "100%" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            width: "100%",
            minHeight: 32,
            gap: 12,
          }}
        >
          <div style={{ flex: 1, minWidth: 0 }} />
          <div
            style={{
              fontWeight: 600,
              textAlign: "center",
              flex: "0 1 auto",
            }}
          >
            {analytics_list_title || "यादी"}
          </div>
          <div
            style={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: 8,
              minWidth: 0,
            }}
          >
            <Button
              type="primary"
              size="small"
              icon={<FileExcelOutlined />}
              disabled={!analytics_list_rows.length || analytics_list_loading}
              onClick={this.downloadAnalyticsListExcel}
            >
              {t("excel")}
            </Button>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
                padding: "4px 12px",
                background: "#f0f5ff",
                border: "1px solid #adc6ff",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 600,
                color: "#1677ff",
                whiteSpace: "nowrap",
              }}
            >
              <span style={{ fontWeight: 500, color: "#595959" }}>
                {t("total")}:
              </span>
              {analytics_list_rows.length}
            </div>
          </div>
        </div>
        {analytics_list_district_name ? (
          <div
            style={{
              fontSize: 14,
              fontWeight: 500,
              color: "#595959",
              marginTop: 4,
              textAlign: "center",
            }}
          >
            पो. स्टे: {analytics_list_district_name}
          </div>
        ) : null}
      </div>
    );

    const analyticsTableScrollX = ["Ongoing", "Completed"].includes(
      analytics_list_type,
    )
      ? 1500
      : analytics_list_type === "twoplusCount"
        ? 1100
        : 1280;

    return (
      <Drawer
        title={drawerTitle}
        visible={analytics_list_visible}
        onClose={this.closeAnalyticsList}
        width={
          isDistrictCountList
            ? Math.min(window.innerWidth * 0.92, 1200)
            : Math.min(window.innerWidth * 0.92, 1100)
        }
        placement="right"
        destroyOnClose
        zIndex={1000}
        bodyStyle={{
          padding: "16px 20px 12px",
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "calc(100% - 55px)",
        }}
      >
        {isCompletedList ? (
          <div
            style={{
              marginBottom: 16,
              padding: "12px 14px",
              background: "#f6ffed",
              border: "1px solid #b7eb8f",
              borderRadius: 8,
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 12,
              flexShrink: 0,
            }}
          >
            <span style={{ fontWeight: 600, color: "#389e0d" }}>
              {dateRangeText ? (
                <div
                  style={{
                    fontSize: 13,
                    fontWeight: 500,
                    color: "#1677ff",
                    marginTop: 4,
                  }}
                >
                  दिनांक: {dateRangeText}
                </div>
              ) : (
                ""
              )}
            </span>
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 10,
              }}
            >
              <Select
                value={analytics_completed_direction}
                onChange={this.onCompletedDirectionFilterChange}
                style={{ minWidth: 130 }}
                dropdownStyle={{ minWidth: 130, zIndex: 1100 }}
                dropdownClassName="completed-days-select-dropdown"
              >
                <Option value="upcoming">पुढील</Option>
                <Option value="past">मागील</Option>
              </Select>
              <Select
                value={Number(analytics_completed_days)}
                onChange={this.onCompletedDaysFilterChange}
                style={{ minWidth: 130 }}
                dropdownStyle={{ minWidth: 130, zIndex: 1100 }}
                dropdownClassName="completed-days-select-dropdown"
              >
                <Option value={7}>7 दिवस</Option>
                <Option value={15}>15 दिवस</Option>
                <Option value={30}>30 दिवस</Option>
              </Select>
            </div>
          </div>
        ) : null}
        <div
          style={{
            flex: 1,
            minHeight: 0,
            overflow: isDistrictCountList ? "auto" : "hidden",
            display: "flex",
            flexDirection: "column",
          }}
        >
          {isDistrictCountList ? (
            <Spin spinning={analytics_list_loading}>
              {analytics_list_rows.length > 0
                ? this.renderAnalyticsDistrictChartView(analytics_list_rows)
                : !analytics_list_loading && this.renderAnalyticsEmptyChart()}
            </Spin>
          ) : (
            <div
              style={{
                flex: 1,
                minHeight: 0,
                width: "100%",
                overflow: "auto",
              }}
            >
              <Table
                rowKey={(record, index) => `${record.id}-${index}`}
                columns={columns}
                dataSource={analytics_list_rows}
                loading={analytics_list_loading}
                pagination={{
                  current: analytics_list_page,
                  pageSize: analytics_list_page_size,
                  showSizeChanger: true,
                  pageSizeOptions: ["10", "20", "50", "100"],
                  position: ["bottomCenter"],
                  style: { marginBottom: 0 },
                  onChange: this.onAnalyticsListPaginationChange,
                  onShowSizeChange: this.onAnalyticsListPageSizeChange,
                }}
                scroll={{
                  x: analyticsTableScrollX,
                  y: isCompletedList
                    ? "calc(100vh - 340px)"
                    : "calc(100vh - 300px)",
                }}
              />
            </div>
          )}
        </div>
      </Drawer>
    );
  };

  renderAnalyticsPieLegend = (data, onCountClick, displayTotal) => {
    const total =
      displayTotal !== undefined && displayTotal !== null
        ? Number(displayTotal)
        : data.reduce((sum, item) => sum + item.value, 0);
    const { t } = this.context;
    return (
      <div
        style={{
          flex: "0 0 42%",
          minWidth: 180,
          padding: "12px 16px",
          background: "#fafafa",
          borderRadius: 8,
          border: "1px solid #f0f0f0",
        }}
      >
        {data.map((item, idx) => (
          <div
            key={item.name}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 8,
              fontSize: 13,
              color: "#595959",
            }}
          >
            <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span
                style={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background:
                    ANALYTICS_PIE_COLORS[idx % ANALYTICS_PIE_COLORS.length],
                  flexShrink: 0,
                }}
              />
              {item.name}
            </span>
            <strong
              style={{
                color: onCountClick ? "#1890ff" : "#262626",
                cursor: onCountClick ? "pointer" : "default",
              }}
              onClick={() => onCountClick && onCountClick(item)}
            >
              {item.value}
            </strong>
          </div>
        ))}
        <div
          style={{
            marginTop: 10,
            padding: "8px 12px",
            background: "#fff",
            borderRadius: 6,
            border: "1px solid #e8e8e8",
            fontWeight: 600,
            fontSize: 13,
            textAlign: "center",
          }}
        >
          {t("total")}: {total.toLocaleString("en-IN")}
        </div>
      </div>
    );
  };

  renderAnalyticsSummaryCard = (
    icon,
    title,
    value,
    iconBg,
    onClick,
    subtitle,
    variant = "horizontal",
  ) => {
    const isCompact = variant === "compact";
    const cardStyle = {
      height: "100%",
      minHeight: isCompact ? 132 : undefined,
      padding: isCompact ? "14px 12px" : "20px 24px",
      borderRadius: 10,
      border: isCompact ? "1px solid #e8e8e8" : "1px solid #d6e4ff",
      background: isCompact
        ? "#fff"
        : "linear-gradient(135deg, #f0f7ff 0%, #ffffff 100%)",
      display: "flex",
      flexDirection: isCompact ? "column" : "row",
      alignItems: isCompact ? "stretch" : "center",
      justifyContent: isCompact ? "space-between" : "flex-start",
      gap: isCompact ? 8 : 16,
      cursor: onClick ? "pointer" : "default",
      userSelect: onClick ? "none" : "auto",
      transition: "box-shadow 0.2s ease, border-color 0.2s ease",
    };

    const interactiveProps = onClick
      ? {
          role: "button",
          tabIndex: 0,
          onClick,
          onKeyDown: (e) => {
            if (e.key === "Enter" || e.key === " ") {
              e.preventDefault();
              onClick();
            }
          },
        }
      : {};

    if (isCompact) {
      return (
        <div {...interactiveProps} style={cardStyle}>
          <div
            style={{
              fontSize: 12,
              fontWeight: 600,
              color: "#595959",
              lineHeight: 1.4,
              minHeight: 34,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {title}
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              marginTop: 4,
            }}
          >
            <div
              style={{
                width: 40,
                height: 40,
                borderRadius: 10,
                background: iconBg,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 18,
                color: "#fff",
                flexShrink: 0,
              }}
            >
              {icon}
            </div>
            <div
              style={{
                fontSize: 28,
                fontWeight: 700,
                color: "#262626",
                lineHeight: 1,
              }}
            >
              {value.toLocaleString("en-IN")}
            </div>
          </div>
          {subtitle ? (
            <div
              style={{
                fontSize: 10,
                color: "#8c8c8c",
                lineHeight: 1.3,
                minHeight: 26,
                display: "-webkit-box",
                WebkitLineClamp: 2,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
              }}
            >
              {subtitle}
            </div>
          ) : (
            <div style={{ minHeight: 26 }} />
          )}
        </div>
      );
    }

    return (
      <div {...interactiveProps} style={cardStyle}>
        <div
          style={{
            width: 52,
            height: 52,
            borderRadius: 12,
            background: iconBg,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontSize: 24,
            color: "#fff",
            flexShrink: 0,
          }}
        >
          {icon}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 13, color: "#8c8c8c", marginBottom: 4 }}>
            {title}
          </div>
          <div
            style={{
              fontSize: 30,
              fontWeight: 700,
              color: "#262626",
              lineHeight: 1,
            }}
          >
            {value.toLocaleString("en-IN")}
          </div>
          {subtitle ? (
            <div style={{ fontSize: 11, color: "#8c8c8c", marginTop: 6 }}>
              {subtitle}
            </div>
          ) : null}
          {onClick && (
            <div style={{ fontSize: 11, color: "#1677ff", marginTop: 6 }}>
              {this.props.user.role != "2"
                ? "पो. स्टे निहाय पहा →"
                : "यादी पहा →"}
            </div>
          )}
        </div>
      </div>
    );
  };

  renderAnalyticsHorizontalBars = (
    data,
    onCountClick,
    trackColor = "#e6f4ff",
    fillGradient = "linear-gradient(90deg, #1890ff 0%, #69b1ff 100%)",
  ) => {
    const maxValue = Math.max(...data.map((item) => item.value), 1);
    return (
      <div style={{ flex: 1, minWidth: 0, paddingRight: 12 }}>
        {data.map((item) => (
          <div key={item.name} style={{ marginBottom: 14 }}>
            <div
              style={{
                fontSize: 13,
                color: "#595959",
                marginBottom: 6,
                fontWeight: 500,
              }}
            >
              {item.name}
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div
                style={{
                  flex: 1,
                  height: 14,
                  background: trackColor,
                  borderRadius: 7,
                  overflow: "hidden",
                }}
              >
                <div
                  style={{
                    width: `${(item.value / maxValue) * 100}%`,
                    height: "100%",
                    background: fillGradient,
                    borderRadius: 7,
                  }}
                />
              </div>
              <span
                style={{
                  fontWeight: 700,
                  fontSize: 14,
                  color: onCountClick ? "#1677ff" : "#262626",
                  minWidth: 28,
                  textAlign: "right",
                  cursor: onCountClick ? "pointer" : "default",
                }}
                onClick={() => onCountClick && onCountClick(item)}
                title={item.name}
              >
                {item.value}
              </span>
            </div>
          </div>
        ))}
      </div>
    );
  };

  renderAnalyticsInsights = (items) => (
    <div
      style={{
        flex: "0 0 38%",
        minWidth: 180,
        padding: "12px 14px",
        background: "#fafafa",
        borderRadius: 8,
        border: "1px solid #f0f0f0",
        fontSize: 12,
        color: "#595959",
        lineHeight: 1.7,
      }}
    >
      {items.map((item) => (
        <div key={item} style={{ display: "flex", gap: 8, marginBottom: 8 }}>
          <span style={{ color: "#1890ff", flexShrink: 0 }}>•</span>
          <span>{item}</span>
        </div>
      ))}
    </div>
  );

  renderAnalyticsEmptyChart = () => {
    const { t } = this.context;

    return (
      <div
        style={{
          height: 280,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8c8c8c",
          fontSize: 14,
        }}
      >
        {t("noDataAvailableForSelectedPeriod")}
      </div>
    );
  };

  renderAnalyticsTab = () => {
    const {
      analytics_startDate,
      analytics_endDate,
      analytics_loading,
      analytics_fetched,
      analytics_range,
      analytics_data,
    } = this.state;
    const { t } = this.context;

    const totalPreventiveActions = Number(
      analytics_data?.preventiveActionCount?.[0]?.total_preventive_actions || 0,
    );
    const totalBondBreaker = Number(
      analytics_data?.boundpreventiveActionCount?.[0]
        ?.total_preventive_actions || 0,
    );
    const totalPoliceStations = Number(
      analytics_data?.police_station_covered?.[0]?.total_police_stations || 0,
    );
    const totalOngoing = Number(
      analytics_data?.onGoiningPreventiveCount?.[0]?.totalCrimeCount || 0,
    );
    const totalCompleted = Number(
      analytics_data?.onCompletedPreventiveCount?.[0]
        ?.totalCompletedPreventiveCount ?? 0,
    );
    const twoplusCount = Number(
      analytics_data?.twoplusCount?.[0]?.totalCrimeCount || 0,
    );
    const completedCardSubtitle =
      analytics_startDate && analytics_endDate
        ? `${moment(analytics_startDate).format("DD/MM/YYYY")} - ${moment(
            analytics_endDate,
          ).format("DD/MM/YYYY")}`
        : "निवडलेला कालावधी";
    const preventiveTypeData = (
      analytics_data?.preventive_action_wise_count || []
    ).map((item) => ({
      name: item.preventive_action_name,
      value: Number(item.count || 0),
      preventive_action: item.preventive_action,
    }));
    const bondBreakerData = (
      analytics_data?.bound_preventive_action_wise_count || []
    ).map((item) => ({
      name: item.preventive_action_name,
      value: Number(item.count || 0),
      preventive_action: item.preventive_action,
    }));
    const topPreventivePs = (
      analytics_data?.top5_district_wise_preventive_tools || []
    ).map((item) => ({
      name: item.name,
      value: Number(item.count || 0),
      district: item.district,
    }));
    const topBondBreakPs = (
      analytics_data?.top_bound_preventive_action_wise_count || []
    ).map((item) => ({
      name: item.name,
      value: Number(item.count || 0),
      district: item.district,
    }));
    const includeZeroBottomStations = ["9", "10"].includes(
      this.props.user?.role,
    );
    const bottomPreventivePs = (
      analytics_data?.bottom5_district_wise_preventive_tools || []
    )
      .filter((item) =>
        includeZeroBottomStations ? true : Number(item.count || 0) > 0,
      )
      .map((item) => ({
        name: item.name,
        value: Number(item.count || 0),
        district: item.district,
      }));
    const bottomPreventivePsCount = bottomPreventivePs.length;

    const isCustomRange = analytics_range === "custom";
    const dateRangeText =
      analytics_startDate && analytics_endDate
        ? `${moment(analytics_startDate).format("DD/MM/YYYY")} - ${moment(analytics_endDate).format("DD/MM/YYYY")}`
        : "From Date - To Date";

    const panelTitleStyle = {
      padding: "10px 16px",
      background: "#f5f5f5",
      borderBottom: "1px solid #f0f0f0",
      fontWeight: 600,
      fontSize: 14,
      color: "#262626",
    };

    const panelStyle = {
      borderRadius: 10,
      border: "1px solid #e8e8e8",
      background: "#fff",
      height: "100%",
      overflow: "hidden",
    };
    const isRole12 = this.props.user?.role === "12";
    const selectedMappedCity = (this.state.mapped_cities || []).find(
      (city) => String(city.id) === String(this.state.selected_city),
    );
    const selectedCityName = isRole12
      ? selectedMappedCity?.city ||
        this.getCityName(this.state.selected_city) ||
        ""
      : "";

    return (
      <div
        style={{
          width: "100%",
          marginTop: 8,
          marginBottom: 24,
        }}
      >
        <Card
          style={{ borderRadius: 12, width: "100%" }}
          bodyStyle={{ padding: "24px 28px" }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              marginBottom: 16,
            }}
          >
            <div>
              <div style={{ fontSize: 22, fontWeight: 700, color: "#1f1f1f" }}>
                {t("analytical")}
              </div>
              <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>
                {t("preventiveBondBreakerAnalysis")}
                {selectedCityName ? ` — ${selectedCityName}` : ""}
              </div>
            </div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 14px",
                borderRadius: 8,
                background: "#f0f7ff",
                border: "1px solid #d6e4ff",
                color: "#1677ff",
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              <CalendarOutlined />
              {dateRangeText}
            </div>
          </div>

          <div className="admin-nd-filters" style={{ marginBottom: 16 }}>
            <div className="admin-nd-filter-grid">
              {isRole12 && (
                <div className="admin-nd-filter-field">
                  <div className="admin-nd-filter-field__inner">
                    <label>City</label>
                    <Select
                      value={this.state.selected_city || undefined}
                      onChange={(value) => {
                        this.setState({ selected_city: value }, () => {
                          this.fetchPreventiveActionAnalytics();
                        });
                      }}
                      style={{ width: "100%" }}
                      placeholder="City"
                    >
                      {(this.state.mapped_cities || []).map((city) => (
                        <Option key={city.id} value={city.id}>
                          {city.city}
                        </Option>
                      ))}
                    </Select>
                  </div>
                </div>
              )}
              <div className="admin-nd-filter-field admin-nd-filter-field--period">
                <div className="admin-nd-filter-field__inner">
                  <label>{t("duration")}</label>
                  <Select
                    value={analytics_range}
                    onChange={this.setAnalyticsQuickRange}
                    style={{ width: "100%" }}
                  >
                    <Option value="1month">1 Month</Option>
                    <Option value="6month">6 Month</Option>
                    <Option value="custom">Custom</Option>
                  </Select>
                </div>
              </div>

              {isCustomRange ? (
                <>
                  <div className="admin-nd-filter-field">
                    <div className="admin-nd-filter-field__inner">
                      <label>From Date</label>
                      <DatePicker
                        value={
                          analytics_startDate
                            ? moment(analytics_startDate)
                            : null
                        }
                        onChange={this.onAnalyticsStartDateChange}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                        inputReadOnly
                        allowClear
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                  <div className="admin-nd-filter-field">
                    <div className="admin-nd-filter-field__inner">
                      <label>To Date</label>
                      <DatePicker
                        value={
                          analytics_endDate ? moment(analytics_endDate) : null
                        }
                        onChange={this.onAnalyticsEndDateChange}
                        placeholder="DD/MM/YYYY"
                        format="DD/MM/YYYY"
                        inputReadOnly
                        allowClear
                        style={{ width: "100%" }}
                      />
                    </div>
                  </div>
                </>
              ) : (
                ""
              )}
            </div>
          </div>

          {analytics_fetched && (
            <Spin spinning={analytics_loading} delay={200}>
              <div
                style={{
                  padding: 16,
                  background: "#fafafa",
                  borderRadius: 12,
                  border: "1px solid #f0f0f0",
                  marginBottom: 16,
                  overflowX: "auto",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(140px, 1fr))",
                    gap: 12,
                    minWidth: 720,
                  }}
                >
                  {this.renderAnalyticsSummaryCard(
                    <SafetyCertificateOutlined />,
                    t("total_preventive_actions"),
                    totalPreventiveActions,
                    "#1890ff",
                    () =>
                      this.openAnalyticsDrill({
                        listType: "district_wise_preventive_total",
                        title: t("policeStationWisePreventiveAction"),
                      }),
                    null,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <DisconnectOutlined />,
                    t("totalBondBreaker"),
                    totalBondBreaker,
                    "#fa8c16",
                    () =>
                      this.openAnalyticsDrill({
                        listType: "district_wise_bond_total",
                        title: t("policeStationWiseBondBreaker"),
                      }),
                    null,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <ClockCircleOutlined />,
                    t("current_preventive_action"),
                    totalOngoing,
                    "#722ed1",
                    () =>
                      this.openAnalyticsDrill({
                        listType: "Ongoing",
                        title: t("current_preventive_action"),
                      }),
                    null,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <CheckCircleOutlined />,
                    t("completed_preventive_action"),
                    totalCompleted,
                    "#52c41a",
                    () =>
                      this.openAnalyticsDrill({
                        listType: "Completed",
                        title: t("completed_preventive_action"),
                      }),
                    completedCardSubtitle,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <ClockCircleOutlined />,
                    t("twoPlusCrimesPreventivePending"),
                    twoplusCount,
                    "#fa541c",
                    () =>
                      this.openAnalyticsDrill({
                        listType: "twoplusCount",
                        title: t("pendingPreventiveActionAccused"),
                      }),
                    null,
                    "compact",
                  )}
                </div>
              </div>

              {this.props.user.role != "2" && (
                <Row gutter={[16, 16]}>
                  <Col xs={24} md={6}>
                    {this.renderAnalyticsSummaryCard(
                      <ArrowDownOutlined />,
                      t("lowestPerformingPoliceStations"),
                      bottomPreventivePsCount,
                      "#ff4d4f",
                      () =>
                        this.openAnalyticsDrill({
                          listType: "bottom5_district_preventive",
                          title: t("lowestPerformingPoliceStations"),
                        }),
                    )}
                  </Col>
                </Row>
              )}

              <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                <Col xs={24} xl={12}>
                  <div style={panelStyle}>
                    <div style={panelTitleStyle}>
                      1.{t("preventiveActionTypeWisePieChart")}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 16,
                        alignItems: "center",
                        padding: 16,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          flex: "1 1 240px",
                          height: 280,
                          minWidth: 220,
                        }}
                      >
                        {preventiveTypeData.length > 0 ? (
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={preventiveTypeData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={105}
                                paddingAngle={2}
                                onClick={(entry) =>
                                  this.openAnalyticsDrill({
                                    listType: "district_wise_preventive_total",
                                    title: `${entry.name} - पो. स्टे निहाय`,
                                    preventive_action: entry.preventive_action,
                                  })
                                }
                              >
                                {preventiveTypeData.map((entry, idx) => (
                                  <Cell
                                    key={`${entry.name}-${idx}`}
                                    fill={
                                      ANALYTICS_PIE_COLORS[
                                        idx % ANALYTICS_PIE_COLORS.length
                                      ]
                                    }
                                    stroke="#fff"
                                    strokeWidth={2}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        ) : (
                          this.renderAnalyticsEmptyChart()
                        )}
                      </div>
                      {preventiveTypeData.length > 0 &&
                        this.renderAnalyticsPieLegend(
                          preventiveTypeData,
                          (item) =>
                            this.openAnalyticsDrill({
                              listType: "district_wise_preventive_total",
                              title: `${item.name} - पो. स्टे निहाय`,
                              preventive_action: item.preventive_action,
                            }),
                          totalPreventiveActions,
                        )}
                    </div>
                  </div>
                </Col>

                <Col xs={24} xl={12}>
                  <div style={panelStyle}>
                    <div style={panelTitleStyle}>
                      2. {t("bondBreakerAnalysisBondWise")}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 16,
                        alignItems: "center",
                        padding: 16,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          flex: "1 1 240px",
                          height: 280,
                          minWidth: 220,
                        }}
                      >
                        {bondBreakerData.length > 0 ? (
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={bondBreakerData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={105}
                                paddingAngle={2}
                                onClick={(entry) =>
                                  this.openAnalyticsDrill({
                                    listType: "bond_by_action",
                                    title: `${entry.name} - Bond Breaker यादी`,
                                    preventive_action: entry.preventive_action,
                                  })
                                }
                              >
                                {bondBreakerData.map((entry, idx) => (
                                  <Cell
                                    key={`${entry.name}-${idx}`}
                                    fill={
                                      ANALYTICS_PIE_COLORS[
                                        idx % ANALYTICS_PIE_COLORS.length
                                      ]
                                    }
                                    stroke="#fff"
                                    strokeWidth={2}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        ) : (
                          this.renderAnalyticsEmptyChart()
                        )}
                      </div>
                      {bondBreakerData.length > 0 &&
                        this.renderAnalyticsPieLegend(
                          bondBreakerData,
                          (item) =>
                            this.openAnalyticsDrill({
                              listType: "bond_by_action",
                              title: `${item.name} - Bond Breaker यादी`,
                              preventive_action: item.preventive_action,
                            }),
                          totalBondBreaker,
                        )}
                    </div>
                    <div style={{ textAlign: "right", padding: "0 16px 16px" }}>
                      <Button type="dashed" size="small">
                        {this.props.user.role != "2" && "पो.स्टे. निहाय तपशील"}
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>
              {this.props.user.role != "2" && (
                <>
                  <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} xl={12}>
                      <div style={panelStyle}>
                        <div style={panelTitleStyle}>
                          <TrophyOutlined
                            style={{ color: "#faad14", marginRight: 8 }}
                          />
                          {t("topPreventiveActionAnalysis")}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: 16,
                            padding: 16,
                            alignItems: "stretch",
                            flexWrap: "wrap",
                          }}
                        >
                          {topPreventivePs.length > 0
                            ? this.renderAnalyticsHorizontalBars(
                                topPreventivePs,
                                (item) =>
                                  this.openAnalyticsDrill({
                                    listType: "district_preventive",
                                    title: "प्रतिबंधक कारवाई यादी",
                                    district: item.district,
                                    districtName: item.name,
                                  }),
                              )
                            : this.renderAnalyticsEmptyChart()}
                          {this.renderAnalyticsInsights(
                            this.buildAnalyticsDistrictInsights(
                              topPreventivePs,
                              "प्रतिबंधक कारवाई",
                            ),
                          )}
                        </div>
                      </div>
                    </Col>

                    <Col xs={24} xl={12}>
                      <div style={panelStyle}>
                        <div style={panelTitleStyle}>
                          <DisconnectOutlined
                            style={{ color: "#1890ff", marginRight: 8 }}
                          />
                          {t("topBondBreakerAnalysis")}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            gap: 16,
                            padding: 16,
                            alignItems: "stretch",
                            flexWrap: "wrap",
                          }}
                        >
                          {topBondBreakPs.length > 0
                            ? this.renderAnalyticsHorizontalBars(
                                topBondBreakPs,
                                (item) =>
                                  this.openAnalyticsDrill({
                                    listType: "district_bond",
                                    title: "Bond Breaker यादी",
                                    district: item.district,
                                    districtName: item.name,
                                  }),
                              )
                            : this.renderAnalyticsEmptyChart()}
                          {this.renderAnalyticsInsights(
                            this.buildAnalyticsDistrictInsights(
                              topBondBreakPs,
                              "Bond Break",
                            ),
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}

              <div
                style={{
                  marginTop: 20,
                  padding: "12px 20px",
                  background: "#fafafa",
                  borderRadius: 8,
                  border: "1px solid #f0f0f0",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap: 12,
                  fontSize: 12,
                  color: "#8c8c8c",
                }}
              >
                <span>
                  <CalendarOutlined style={{ marginRight: 6 }} />
                  {t("duration")}: {dateRangeText}
                </span>
                <span>
                  <BankOutlined />
                  {t("policeStationCoverage")}: {totalPoliceStations}
                </span>
                <span>{t("dataSource")}: CMIS</span>
                <span>
                  {t("lastUpdatedTime")}: {moment().format("hh:mm A")}
                </span>
              </div>
            </Spin>
          )}
        </Card>
      </div>
    );
  };
  renderAnalyticsDistictTab = () => {
    const {
      analytics_startDate,
      analytics_endDate,
      analytics_loading,
      analytics_fetched,
      analytics_range,
      analytics_data,
      analytics_completed_days,
      analytics_completed_direction,
    } = this.state;
    const { t } = this.context;
    const totalPreventiveActions = Number(
      analytics_data?.onpreventiveCount?.[0]?.total_preventive_actions || 0,
    );
    const totalBondBreaker = Number(
      analytics_data?.onBoundBreak?.[0]?.total_preventive_actions || 0,
    );
    const totalOngoing = Number(
      analytics_data?.onGoiningPreventiveCount?.[0]?.totalCrimeCount || 0,
    );
    const totalCompleted = Number(
      analytics_data?.onCompletedPreventiveCount?.[0]
        ?.totalCompletedPreventiveCount ?? 0,
    );
    const twoplusCount = Number(
      analytics_data?.twoplusCount?.[0]?.totalCrimeCount || 0,
    );
    const completedCardSubtitle =
      analytics_startDate && analytics_endDate
        ? `${moment(analytics_startDate).format("DD/MM/YYYY")} - ${moment(
            analytics_endDate,
          ).format("DD/MM/YYYY")}`
        : "निवडलेला कालावधी";
    const preventiveTypeData = (
      analytics_data?.onPreventiveActionTypeWiseCount || []
    ).map((item) => ({
      name: item.preventive_action_name,
      value: Number(item.count || 0),
      preventive_action: item.preventive_action,
    }));
    const bondBreakerData = (analytics_data?.onBoundBreakWiseCount || []).map(
      (item) => ({
        name: item.preventive_action_name,
        value: Number(item.total_preventive_actions || 0),
        preventive_action: item.preventive_action,
      }),
    );
    const isCustomRange = analytics_range === "custom";
    const dateRangeText =
      analytics_startDate && analytics_endDate
        ? `${moment(analytics_startDate).format("DD/MM/YYYY")} - ${moment(analytics_endDate).format("DD/MM/YYYY")}`
        : "From Date - To Date";

    const panelTitleStyle = {
      padding: "10px 16px",
      background: "#f5f5f5",
      borderBottom: "1px solid #f0f0f0",
      fontWeight: 600,
      fontSize: 14,
      color: "#262626",
    };

    const panelStyle = {
      borderRadius: 10,
      border: "1px solid #e8e8e8",
      background: "#fff",
      height: "100%",
      overflow: "hidden",
    };

    return (
      <div
        style={{
          width: "100%",
          marginTop: 8,
          marginBottom: 24,
        }}
      >
        <Card
          style={{ borderRadius: 12, width: "100%" }}
          bodyStyle={{ padding: "24px 28px" }}
        >
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
              alignItems: "center",
              gap: 12,
              marginBottom: 16,
            }}
          >
            <div>
              <div style={{ fontSize: 22, fontWeight: 700, color: "#1f1f1f" }}>
                {t("analytical")}
              </div>
              <div style={{ fontSize: 13, color: "#8c8c8c", marginTop: 4 }}>
                {t("preventiveBondBreakerAnalysis")}
              </div>
            </div>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "8px 14px",
                borderRadius: 8,
                background: "#f0f7ff",
                border: "1px solid #d6e4ff",
                color: "#1677ff",
                fontSize: 13,
                fontWeight: 600,
              }}
            >
              <CalendarOutlined />
              {dateRangeText}
            </div>
          </div>

          <div className="admin-nd-filter-field admin-nd-filter-field--period">
            <div className="admin-nd-filter-field__inner">
              <label
                style={{ fontSize: 12, fontWeight: 600, color: "#595959" }}
              >
                {t("duration")}
              </label>
              <Select
                value={analytics_range}
                onChange={this.setAnalyticsQuickRange}
                style={{ minWidth: 160 }}
                dropdownStyle={{ minWidth: "160px" }}
              >
                <Option value="1month">1 Month</Option>
                <Option value="6month">6 Month</Option>
                <Option value="custom">Custom</Option>
              </Select>
            </div>

            {isCustomRange ? (
              <>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 4 }}
                >
                  <label
                    style={{ fontSize: 12, fontWeight: 600, color: "#595959" }}
                  >
                    From Date
                  </label>
                  <DatePicker
                    value={
                      analytics_startDate ? moment(analytics_startDate) : null
                    }
                    onChange={this.onAnalyticsStartDateChange}
                    placeholder="DD/MM/YYYY"
                    format="DD/MM/YYYY"
                    inputReadOnly
                    allowClear
                    style={{ width: 150 }}
                  />
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column", gap: 4 }}
                >
                  <label
                    style={{ fontSize: 12, fontWeight: 600, color: "#595959" }}
                  >
                    To Date
                  </label>
                  <DatePicker
                    value={analytics_endDate ? moment(analytics_endDate) : null}
                    onChange={this.onAnalyticsEndDateChange}
                    placeholder="DD/MM/YYYY"
                    format="DD/MM/YYYY"
                    inputReadOnly
                    allowClear
                    style={{ width: 150 }}
                  />
                </div>
              </>
            ) : (
              ""
            )}
          </div>

          {analytics_fetched && (
            <Spin spinning={analytics_loading} delay={200}>
              <div
                style={{
                  padding: 16,
                  background: "#fafafa",
                  borderRadius: 12,
                  border: "1px solid #f0f0f0",
                  marginBottom: 16,
                  overflowX: "auto",
                }}
              >
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(5, minmax(140px, 1fr))",
                    gap: 12,
                    minWidth: 720,
                  }}
                >
                  {this.renderAnalyticsSummaryCard(
                    <SafetyCertificateOutlined />,
                    t("total_preventive_actions"),
                    totalPreventiveActions,
                    "#1890ff",
                    null,
                    null,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <DisconnectOutlined />,
                    "एकुण कारवाई चे उल्लंघन करणारे आरोपी",
                    totalBondBreaker,
                    "#fa8c16",
                    null,
                    null,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <ClockCircleOutlined />,
                    "चालु प्रतिबंधक कारवाई",
                    totalOngoing,
                    "#722ed1",
                    () =>
                      this.openDistrictAnalyticsList({
                        listType: "Ongoing",
                        title: "चालु प्रतिबंधक कारवाई",
                      }),
                    null,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <CheckCircleOutlined />,
                    "संपलेली प्रतिबंधक कारवाई",
                    totalCompleted,
                    "#52c41a",
                    () =>
                      this.openDistrictAnalyticsList({
                        listType: "Completed",
                        title: "संपलेली प्रतिबंधक कारवाई",
                      }),
                    completedCardSubtitle,
                    "compact",
                  )}
                  {this.renderAnalyticsSummaryCard(
                    <ClockCircleOutlined />,
                    "२+ गुन्हे - प्रतिबंधक बाकी",
                    twoplusCount,
                    "#fa541c",
                    () =>
                      this.openDistrictAnalyticsList({
                        listType: "twoplusCount",
                        title:
                          "अद्याप प्रतिबंधक कारवाई न झालेली आरोपी : 2 प्लस आरोपी/ एक गुन्हा असलेले.",
                      }),
                    null,
                    "compact",
                  )}
                </div>
              </div>

              <Row gutter={[16, 16]}>
                <Col xs={24} xl={12}>
                  <div style={panelStyle}>
                    <div style={panelTitleStyle}>
                      1. प्रतिबंधक कारवाई प्रकारानुसार पाई चार्ट
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 16,
                        alignItems: "center",
                        padding: 16,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          flex: "1 1 240px",
                          height: 280,
                          minWidth: 220,
                        }}
                      >
                        {preventiveTypeData.length > 0 ? (
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={preventiveTypeData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={105}
                                paddingAngle={2}
                                onClick={(entry) =>
                                  this.openDistrictAnalyticsList({
                                    listType: "Preventive_Wise",
                                    title: `${entry.name} - पो. स्टे निहाय`,
                                    preventive_action: entry.preventive_action,
                                  })
                                }
                              >
                                {preventiveTypeData.map((entry, idx) => (
                                  <Cell
                                    key={`${entry.name}-${idx}`}
                                    fill={
                                      ANALYTICS_PIE_COLORS[
                                        idx % ANALYTICS_PIE_COLORS.length
                                      ]
                                    }
                                    stroke="#fff"
                                    strokeWidth={2}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        ) : (
                          this.renderAnalyticsEmptyChart()
                        )}
                      </div>
                      {preventiveTypeData.length > 0 &&
                        this.renderAnalyticsPieLegend(
                          preventiveTypeData,
                          (item) =>
                            this.openDistrictAnalyticsList({
                              listType: "Preventive_Wise",
                              title: `${item.name} - पो. स्टे निहाय`,
                              preventive_action: item.preventive_action,
                            }),
                          totalPreventiveActions,
                        )}
                    </div>
                  </div>
                </Col>

                <Col xs={24} xl={12}>
                  <div style={panelStyle}>
                    <div style={panelTitleStyle}>
                      2. {t("totalBondBreakerPieChart")}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        gap: 16,
                        alignItems: "center",
                        padding: 16,
                        flexWrap: "wrap",
                      }}
                    >
                      <div
                        style={{
                          flex: "1 1 240px",
                          height: 280,
                          minWidth: 220,
                        }}
                      >
                        {bondBreakerData.length > 0 ? (
                          <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                              <Pie
                                data={bondBreakerData}
                                dataKey="value"
                                nameKey="name"
                                cx="50%"
                                cy="50%"
                                innerRadius={60}
                                outerRadius={105}
                                paddingAngle={2}
                                onClick={(entry) =>
                                  this.openDistrictAnalyticsList({
                                    listType: "Bound Break",
                                    title: `${entry.name} - Bond Breaker यादी`,
                                    preventive_action: entry.preventive_action,
                                  })
                                }
                              >
                                {bondBreakerData.map((entry, idx) => (
                                  <Cell
                                    key={`${entry.name}-${idx}`}
                                    fill={
                                      ANALYTICS_PIE_COLORS[
                                        idx % ANALYTICS_PIE_COLORS.length
                                      ]
                                    }
                                    stroke="#fff"
                                    strokeWidth={2}
                                  />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        ) : (
                          this.renderAnalyticsEmptyChart()
                        )}
                      </div>
                      {bondBreakerData.length > 0 &&
                        this.renderAnalyticsPieLegend(
                          bondBreakerData,
                          (item) =>
                            this.openDistrictAnalyticsList({
                              listType: "Bound Break",
                              title: `${item.name} - Bond Breaker यादी`,
                              preventive_action: item.preventive_action,
                            }),
                          totalBondBreaker,
                        )}
                    </div>
                    <div style={{ textAlign: "right", padding: "0 16px 16px" }}>
                      <Button type="dashed" size="small">
                        {this.props.user.role != "2" && "पो.स्टे. निहाय तपशील"}
                      </Button>
                    </div>
                  </div>
                </Col>
              </Row>

              <div
                style={{
                  marginTop: 20,
                  padding: "12px 20px",
                  background: "#fafafa",
                  borderRadius: 8,
                  border: "1px solid #f0f0f0",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "space-between",
                  gap: 12,
                  fontSize: 12,
                  color: "#8c8c8c",
                }}
              >
                <span>
                  <CalendarOutlined style={{ marginRight: 6 }} />
                  {t("duration")}: {dateRangeText}
                </span>

                <span>{t("dataSource")}: CMIS</span>
                <span>
                  {t("lastUpdatedTime")}: {moment().format("hh:mm A")}
                </span>
              </div>
            </Spin>
          )}
        </Card>
      </div>
    );
  };

  handleAdvancedFilterPhotoChange = (e) => {
    const value = e.target.value;
    this.setState({ advancedFilterPhoto: value });

    const { report4_List_backup, report4_List } = this.state; // keep original data safe

    let filtered;

    if (value === "yes") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo !== null && item.photo !== "" && item.photo !== undefined,
      );
    } else if (value === "no") {
      filtered = report4_List_backup.filter(
        (item) =>
          item.photo === null || item.photo === "" || item.photo === undefined,
      );
    } else {
      filtered = report4_List_backup;
    }

    this.setState({
      total: filtered.length,
      preventiveList: filtered,
    });
  };
  render() {
    const labelStyle = {
      fontSize: "14px",
      fontWeight: "500",
      color: "#262626",
      minWidth: "140px", // same for all
      display: "inline-block",
    };
    const yearOptions = [];
    for (let y = 2010; y <= 2025; y++) {
      yearOptions.push(y);
    }
    const { user } = this.props;
    const { t } = this.context;
    const {
      showList,
      preventiveAction,
      preventive_action_mode,
      selectedDate,
      download,
      reportList,
      selectedHeadings,
      direction,
      key,
      activeRange,
      report_1_endDate,
      report_1_startDate,
      selected_city,
      mapped_cities,
    } = this.state;
    console.log("preventive_action", preventive_action_mode, showList);
    console.log("preventive_action1234", preventiveAction);
    console.log("selectedHeadings", selectedHeadings);
    const menu = (
      <Menu onClick={this.filterkey} style={{ width: "200px", padding: "8px" }}>
        <Menu.Item key="name">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {t("sort_by_name")}

            <ArrowUpOutlined
              title="ASC"
              style={{
                color:
                  key === "name" && direction === "ASC" ? "#1890ff" : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "ASC")} // Toggle to ASC on click
            />
            <ArrowDownOutlined
              title="DESC"
              style={{
                color:
                  key === "name" && direction === "DESC"
                    ? "#1890ff"
                    : "#bfbfbf",
              }}
              onClick={() => this.sortby("name", "DESC")} // Toggle to DESC on click
            />
          </div>
        </Menu.Item>
        {this.state.showList == "यादी" &&
          preventive_action_mode != "प्रतिबंधक कारवाईचे उल्लंघन" && (
            <>
              <Menu.Item key="districtName">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {this.props.users && this.props.users.role === "2"
                    ? t("sort_by_police_station")
                    : t("sort_by_district_name")}

                  <ArrowUpOutlined
                    title="ASC"
                    style={{
                      color:
                        key === "districtName" && direction === "ASC"
                          ? "#1890ff"
                          : "#bfbfbf",
                    }}
                    onClick={() => this.sortby("districtName", "ASC")} // Toggle to ASC
                  />
                  <ArrowDownOutlined
                    title="DESC"
                    style={{
                      color:
                        key === "districtName" && direction === "DESC"
                          ? "#1890ff"
                          : "#bfbfbf",
                    }}
                    onClick={() => this.sortby("districtName", "DESC")} // Toggle to DESC
                  />
                </div>
              </Menu.Item>

              <Menu.Item key="totalCrimeCount">
                <div
                  style={{ display: "flex", alignItems: "center", gap: "8px" }}
                >
                  {t("sort_by_total_crimes")}

                  <ArrowUpOutlined
                    title="ASC"
                    style={{
                      color:
                        key === "totalCrimeCount" && direction === "ASC"
                          ? "#1890ff"
                          : "#bfbfbf",
                    }}
                    onClick={() => this.sortby("totalCrimeCount", "ASC")} // Toggle to ASC
                  />
                  <ArrowDownOutlined
                    title="DESC"
                    style={{
                      color:
                        key === "totalCrimeCount" && direction === "DESC"
                          ? "#1890ff"
                          : "#bfbfbf",
                    }}
                    onClick={() => this.sortby("totalCrimeCount", "DESC")} // Toggle to DESC
                  />
                </div>
              </Menu.Item>
            </>
          )}
      </Menu>
    );

    const {
      criminalViewList,
      pc_cities,
      loading,
      pc_crimetypes,
      pc_crimetitles,
    } = this.props.professionals;
    const { professionals } = this.props;

    this.state.reportList.forEach((item) => {
      if (
        Array.isArray(item.photo) &&
        item.photo.length === 1 &&
        typeof item.photo[0] === "string" &&
        item.photo[0].includes(",")
      ) {
        const newPhotos = item.photo[0].split(",");

        item.photo = [newPhotos[0], ...newPhotos.slice(1)];

        console.log("Updated item.photo", item.photo);
      }
    });

    // const formattedList = this.state?.reportList.forEach((item) => {
    //   if (item?.photo && Array.isArray(item.photo)) {
    //     return item.photo.flatMap((ph) => return(
    //       if(ph){
    //         item.photo.push(ph)
    //       }
    //     ));
    //   }
    //   return item;
    // });

    console.log("this.state.reportList", this.state.reportList);

    const showAnalyticsToggle =
      ["2", "4", "9", "10"].includes(user.role) ||
      (user.role === "12" && !!selected_city);

    return (
      <Spin spinning={this.state.loading} delay={500}>
        <div
          className={
            this.state.showAnalytics ? "col-md-12" : "col-md-6 col-md-offset-3"
          }
        >
          <div className="site-page-header-ghost-wrapper">
            <PageHeader
              className="site-page-header"
              ghost={false}
              onBack={false}
              // title={user && user.userid}
              // subTitle={
              //   user && user.role === "4" ? "( ADMIN )" : "( SUPER ADMIN )"
              // }
            ></PageHeader>

            <PageHeader
              className="site-page-header"
              ghost={false}
              title={t("preventive_action")}
              extra={
                showAnalyticsToggle ? (
                  <>
                    <div className="admin-nd-header__actions">
                      <div
                        className="admin-nd-ps-badge admin-nd-ps-badge--clickable"
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          this.setState(
                            (prev) => ({
                              showAnalytics: !prev.showAnalytics,
                            }),
                            () => {
                              if (this.state.showAnalytics) {
                                this.fetchPreventiveActionAnalytics();
                              }
                            },
                          )
                        }
                      >
                        {this.state.showAnalytics ? (
                          <UnorderedListOutlined />
                        ) : (
                          <BarChartOutlined />
                        )}
                        <span>
                          {this.state.showAnalytics
                            ? t("list")
                            : t("analytical")}
                        </span>
                      </div>
                    </div>
                  </>
                ) : null
              }
            />
            {!this.state.showAnalytics && (
              <>
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "12px",
                    alignItems: "center",
                    background: "#fff",
                    padding: "16px",
                    borderRadius: "8px",
                  }}
                >
                  {this.props.user.role === "12" && (
                    <Form.Item
                      name="selected_city"
                      label="City"
                      labelCol={{ style: { whiteSpace: "nowrap" } }}
                      style={{ width: "100%" }}
                    >
                      <Select
                        style={{
                          width: "100%",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                        value={this.state.selected_city}
                        onChange={(e) => {
                          this.setState({ selected_city: e }, () => {
                            if (!e) {
                              this.setState({ showAnalytics: false });
                              return;
                            }
                            if (this.state.showAnalytics) {
                              this.fetchPreventiveActionAnalytics();
                            }
                          });
                        }}
                        placeholder={t("please_select_a_report")}
                      >
                        {mapped_cities.length > 0 &&
                          mapped_cities.map((cities, index) => (
                            <Option value={cities.id}>{cities.city}</Option>
                          ))}
                      </Select>
                    </Form.Item>
                  )}
                  {/* Preventive Action Dropdown */}
                  <Select
                    placeholder="select प्रतिबंधक कारवाही"
                    onChange={this.setPrevetiveMode}
                    defaultValue="चालु प्रतिबंधक कारवाही"
                    style={{ minWidth: 220 }}
                    dropdownStyle={{ minWidth: "200px" }}
                  >
                    <Option value="चालु प्रतिबंधक कारवाही">
                      {t("current_preventive_action")}
                    </Option>
                    <Option value="संपलेले प्रतिबंधक कारवाही">
                      {t("completed_preventive_action")}
                    </Option>
                    <Option value="बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही">
                      {t("preventive_action")}
                    </Option>
                    <Option value="प्रतिबंधक कारवाईचे उल्लंघन">
                      {t("violated_preventive_action")}
                    </Option>
                  </Select>

                  <Space>
                    {this.state.preventive_action_mode !==
                      "चालु प्रतिबंधक कारवाही" && (
                      <>
                        {/* Show Daily / Weekly / Month ONLY for other modes */}
                        {this.state.preventive_action_mode !==
                          "संपलेले प्रतिबंधक कारवाही" && (
                          <>
                            <Button
                              size="small"
                              type={
                                this.state.activeRange === "daily"
                                  ? "primary"
                                  : "default"
                              }
                              onClick={() => this.setQuickRange("daily")}
                            >
                              Daily
                            </Button>

                            <Button
                              size="small"
                              type={
                                this.state.activeRange === "weekly"
                                  ? "primary"
                                  : "default"
                              }
                              onClick={() => this.setQuickRange("weekly")}
                            >
                              Weekly
                            </Button>

                            <Button
                              size="small"
                              type={
                                this.state.activeRange === "month"
                                  ? "primary"
                                  : "default"
                              }
                              onClick={() => this.setQuickRange("month")}
                            >
                              Month
                            </Button>
                          </>
                        )}

                        {/* Custom is visible for both cases */}
                        <Button
                          size="small"
                          type={
                            this.state.activeRange === "custom"
                              ? "primary"
                              : "default"
                          }
                          onClick={() => this.setQuickRange("custom")}
                        >
                          Custom
                        </Button>
                      </>
                    )}
                  </Space>
                  {/* चालु प्रतिबंधक कारवाही → only one DatePicker */}
                  {this.state.preventive_action_mode ===
                  "चालु प्रतिबंधक कारवाही" ? (
                    <DatePicker
                      onChange={this.handleDateChange}
                      value={this.state.selectedDate}
                      style={{ minWidth: 180 }}
                      inputReadOnly
                      placeholder="DD/MM/YYYY"
                      format="DD/MM/YYYY"
                    />
                  ) : (
                    <>
                      {/* Custom → Start & End Date */}
                      {this.state.activeRange === "custom" ? (
                        <>
                          <DatePicker
                            style={{ flex: 1, minWidth: "150px" }}
                            value={
                              this.state.report_1_startDate
                                ? moment(this.state.report_1_startDate)
                                : null
                            }
                            onChange={this.onStartDateChange}
                            placeholder="DD/MM/YYYY"
                            allowClear
                            format="DD/MM/YYYY"
                            inputReadOnly
                          />

                          <DatePicker
                            style={{
                              flex: 1,
                              minWidth: "150px",
                              marginLeft: "10px",
                            }}
                            value={
                              this.state.report_1_endDate
                                ? moment(this.state.report_1_endDate)
                                : null
                            }
                            onChange={this.onEndDateChange}
                            placeholder="DD/MM/YYYY"
                            allowClear
                            format="DD/MM/YYYY"
                            inputReadOnly
                          />
                        </>
                      ) : (
                        <DatePicker
                          onChange={this.handleDateChange}
                          value={this.state.selectedDate}
                          style={{ minWidth: 180 }}
                          inputReadOnly
                          placeholder="DD/MM/YYYY"
                          format="DD/MM/YYYY"
                        />
                      )}
                    </>
                  )}

                  {/* Find Button */}
                  <Button
                    type="primary"
                    disabled={
                      this.state.activeRange === "custom"
                        ? !this.state.report_1_startDate &&
                          !this.state.report_1_endDate
                        : !selectedDate ||
                          (this.props.user?.role === "12" &&
                            !this.state.selected_city)
                    }
                    loading={this.state.report1_API_loader}
                    onClick={this.getData}
                    icon={<SearchOutlined />}
                  >
                    {t("find")}
                  </Button>

                  {/* Download Section */}
                  <Select
                    placeholder={t("please_select_an_option")}
                    value={this.state.download}
                    onChange={(value) => this.setState({ download: value })}
                    style={{ minWidth: 120 }}
                    disabled={!this.state.is_data}
                  >
                    <Option value="excel">{t("excel")}</Option>
                    <Option value="pdf">PDF</Option>
                  </Select>
                  {this.state.download && (
                    <Button
                      type="primary"
                      onClick={() => this.downloadReport()}
                      disabled={!this.state.is_data}
                    >
                      {t("download")}
                    </Button>
                  )}
                  {showList == "यादी" && (
                    <Button
                      icon={<FilterOutlined />}
                      onClick={() =>
                        this.setState({
                          showFilterSection: !this.state.showFilterSection,
                        })
                      }
                      disabled={
                        !this.state.reportList.length ||
                        !this.state.reportList1.length
                      }
                    >
                      {t("filter")}
                    </Button>
                  )}
                </div>
                {this.state.showFilterSection == true && (
                  <div
                    style={{
                      marginTop: "16px",
                      padding: "16px",
                      background: "#fff",
                      borderRadius: "8px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "16px",
                      marginBottom: "25px",
                    }}
                  >
                    {/* प्रतिबंधक कारवाही select */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={labelStyle}>{t("preventive_action")}:</span>
                      <Select
                        optionFilterProp="children"
                        placeholder="Please select प्रतिबंधक कारवाही"
                        mode="multiple"
                        value={this.state.selectedHeadings}
                        disabled={
                          this.state.reportList1 == 0 ||
                          this.state.reportList === 0
                        }
                        onChange={(val) => this.handlePrventive(val)}
                        style={{ flex: 1 }}
                        dropdownStyle={{ minWidth: "250px" }}
                        maxTagCount="responsive"
                        maxTagTextLength={20}
                      >
                        {preventiveAction.map((res, index) => (
                          <Option key={index} value={res.id}>
                            {res.name}
                          </Option>
                        ))}
                      </Select>
                    </div>

                    {/* Search box */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                      }}
                    >
                      <span style={labelStyle}>{t("search")}:</span>
                      <Input
                        placeholder="Search..."
                        value={this.state.searchText}
                        onChange={this.handleInputChange}
                        style={{ flex: 1, borderRadius: "6px" }}
                        allowClear
                      />
                    </div>

                    {/* Year select */}
                    {preventive_action_mode ===
                      "प्रतिबंधक कारवाईचे उल्लंघन" && (
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <span style={labelStyle}>{t("crimes_year")}</span>
                        <Select
                          placeholder={t("crimes_year")}
                          value={this.state.year}
                          onChange={(val) => this.handleYear(val.map(Number))}
                          mode="multiple"
                          allowClear
                          size="middle"
                          style={{ flex: 1 }}
                          showSearch
                          filterOption={(input, option) =>
                            option.children
                              .toString()
                              .toLowerCase()
                              .includes(input.toLowerCase())
                          }
                          maxTagCount={1}
                        >
                          {yearOptions.map((y) => (
                            <Option key={y} value={y}>
                              {y}
                            </Option>
                          ))}
                        </Select>
                      </div>
                    )}

                    {/* Dropdown for sorting */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                      }}
                    >
                      <Dropdown
                        overlay={menu}
                        disabled={!this.state.reportList?.length}
                        placement="bottomRight"
                        arrow={{ pointAtCenter: true }}
                        overlayStyle={{ width: "200px" }} // Smaller dropdown size
                      >
                        <Button
                          type="ghost" // Ant Design's default blue style
                          style={{
                            width: "120px", // Smaller button size
                            backgroundColor: "#1890ff", // Blue color
                            borderColor: "#1890ff",
                          }}
                          className="modern-button"
                        >
                          {t("sorter_by")} <DownOutlined />
                        </Button>
                      </Dropdown>
                    </div>

                    {/* Button group at bottom right */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "12px",
                      }}
                    >
                      <Button
                        type="primary"
                        disabled={
                          !(
                            this.state.selectedHeadings.length > 0 ||
                            this.state.searchText ||
                            this.state.year.length > 0 ||
                            this.state.order_by != "" ||
                            this.state.direction != ""
                          ) ||
                          this.state.reportList1 === 0 ||
                          this.state.reportList === 0
                        }
                        loading={this.state.report1_API_loader}
                        onClick={() => this.handlePrventiveFind()}
                        icon={<SearchOutlined />}
                        className="modern-button modern-button-success"
                      >
                        {t("find")}
                      </Button>
                      {(this.state.selectedHeadings.length > 0 ||
                        this.state.searchText ||
                        this.state.is_sort ||
                        this.state.year.length > 0) && (
                        <Button
                          onClick={() => this.clearFilter()}
                          icon={<ClearOutlined />}
                          className="modern-button modern-button-danger"
                        >
                          {t("clear")}
                        </Button>
                      )}
                    </div>
                  </div>
                )}
                {this.state.showList === "यादी" &&
                  this.state.preventive_action_mode !=
                    "प्रतिबंधक कारवाईचे उल्लंघन" &&
                  this.state.preventiveList.length > 0 && (
                    <div
                      style={{
                        marginTop: "20px",
                        display: "flex",
                        alignItems: "center",
                        gap: "16px",
                      }}
                    >
                      <label style={{ fontSize: "15px", fontWeight: "500" }}>
                        फोटो:
                      </label>

                      <Radio.Group
                        onChange={this.handleAdvancedFilterPhotoChange}
                        value={this.state.advancedFilterPhoto}
                      >
                        <Radio value="all">सर्व</Radio>
                        <Radio value="yes">होय</Radio>
                        <Radio value="no">नाही</Radio>
                      </Radio.Group>
                    </div>
                  )}

                <React.Suspense fallback={<div>Loading...</div>}>
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "16px",
                        width: "100%",
                        padding: "16px 0",
                      }}
                    >
                      {/* View Type Selection */}
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "12px",
                          alignItems: "center",
                          padding: "12px",
                          background: "#f5f5f5",
                          borderRadius: "8px",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            gap: "8px",
                            flexWrap: "wrap",
                            alignItems: "center",
                          }}
                        >
                          {user &&
                            ["4", "9", "10", "12"].includes(user.role) && (
                              <Button
                                type={
                                  showList == "सांख्यिकी"
                                    ? "primary"
                                    : "default"
                                }
                                onClick={() => this.getShowList("सांख्यिकी")}
                                icon={<BarChartOutlined />}
                                style={{
                                  minWidth: "120px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "8px",
                                }}
                              >
                                {t("statistics")}
                              </Button>
                            )}

                          <Button
                            type={showList == "यादी" ? "primary" : "default"}
                            onClick={() => this.getShowList("यादी")}
                            icon={<UnorderedListOutlined />}
                            style={{
                              minWidth: "120px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              gap: "8px",
                            }}
                          >
                            {t("list")}
                          </Button>

                          {/* {this.state.reportList1.length > 0 &&
                        this.state.showList == "यादी" && (
                          <div
                            style={{
                              padding: "4px 12px",
                              background: "#fff",
                              borderRadius: "4px",
                              border: "1px solid #d9d9d9",
                              display: "flex",
                              alignItems: "center",
                              gap: "8px",
                            }}
                          >
                            <span style={{ color: "#666" }}>एकुण:</span>
                            <span style={{ fontWeight: "bold" }}>
                              {this.state.reportList.length}
                            </span>
                          </div>
                        )} */}
                        </div>
                      </div>

                      {/* Table Section */}
                      <div
                        style={{
                          width: "100%",
                          overflowX: "auto",
                          background: "#fff",
                          borderRadius: "8px",
                          border: "1px solid #f0f0f0",
                          boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                        }}
                      >
                        {showList == "सांख्यिकी" ? (
                          <NewReport1
                            {...this.props}
                            data={this.state.preventiveListCount}
                            preventiveAction={preventiveAction}
                            user={user}
                            onEditAccusedForm={this.onEditAccusedForm}
                            preventiveActionData={
                              this.state.preventiveActionData
                            }
                            professionals={this.props.professionals}
                            report_1_startDate={this.state.report_1_startDate}
                            report_1_endDate={this.state.report_1_endDate}
                            report={
                              preventive_action_mode ===
                                "बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही" ||
                              preventive_action_mode === null
                                ? true
                                : false
                            }
                            ongoing={
                              preventive_action_mode ===
                              "चालु प्रतिबंधक कारवाही"
                                ? true
                                : false
                            }
                            completed={
                              preventive_action_mode ===
                              "संपलेले प्रतिबंधक कारवाही"
                                ? true
                                : false
                            }
                            selectedDate={this.state.selectedDate}
                            loading={this.state.report1_API_loader}
                            endDate={
                              activeRange === "custom"
                                ? moment(report_1_endDate).format("YYYY-MM-DD")
                                : moment(selectedDate).format("YYYY-MM-DD")
                            }
                            rangeType={activeRange}
                            startDate={
                              activeRange === "custom" &&
                              moment(report_1_startDate).format("YYYY-MM-DD")
                            }
                            label={
                              ["4", "12"].includes(user.role)
                                ? "admin"
                                : user.role === "2"
                                  ? "ps"
                                  : "officer"
                            }
                            cityId={user.cityId}
                            district={user.role == "2" && user.districtId}
                            districtArray={
                              user.role === "9" ||
                              (user.role === "10" && user.map_districtId)
                            }
                            selectedCity={
                              this.props.user.role === "12" && selected_city
                            }
                          />
                        ) : (
                          <TablePreventiveReport
                            showList={this.state.showList}
                            loading={this.state.report1_API_loader}
                            report={
                              preventive_action_mode ===
                                "बंधपत्र घेतल्याचा दिनांक प्रतिबंधक कारवाही" ||
                              preventive_action_mode === null
                                ? true
                                : false
                            }
                            ongoing={
                              preventive_action_mode ===
                              "चालु प्रतिबंधक कारवाही"
                                ? true
                                : false
                            }
                            completed={
                              preventive_action_mode ===
                              "संपलेले प्रतिबंधक कारवाही"
                                ? true
                                : false
                            }
                            new={
                              preventive_action_mode ===
                              "नव्याने केलेल्या प्रतिबंधक कारवाई"
                                ? true
                                : false
                            }
                            violators_list={
                              preventive_action_mode ===
                              "प्रतिबंधक कारवाईचे उल्लंघन"
                                ? true
                                : false
                            }
                            data={this.state.preventiveList}
                            reportList1={this.state.reportList1}
                            onTableSortChange={this.handleTableSortChange}
                            report_1_startDate={this.state.report_1_startDate}
                            report_1_endDate={this.state.report_1_endDate}
                            selectedDate={this.state.selectedDate}
                            preventiveAction={this.state.preventiveActionData}
                            preventive_action={this.state.preventive_action}
                            onViewAccusedForm={this.onViewAccusedForm}
                            cityId={
                              this.props
                                ? this.props?.user && this.props?.user.cityId
                                : null
                            }
                            role={this.props ? this.props.user.role : null}
                            userId={this.props ? this.props.user.id : null}
                            startDate={this.state.report_1_startDate}
                            endDate={this.state.report_1_endDate}
                            headings={this.state.selectedHeadings}
                            clearData={this.clearFilter}
                            searchText={this.state.searchText}
                            professionals={this.props.professionals}
                          />
                        )}
                      </div>
                    </div>
                  </>
                </React.Suspense>
              </>
            )}
            {this.state.showAnalytics &&
            (["2", "4", "9", "10"].includes(this.props.user.role) ||
              (this.props.user.role === "12" && this.state.selected_city))
              ? this.renderAnalyticsTab()
              : ""}
          </div>
          {/* <ReportsTable
            isNotloading={this.isNotloading}
            ref={this.myTableRef}
            rows={
              showList === "सांख्यिकी"
                ? this.state.preventiveListCount
                : this.state.reportList
            }
            startDate={this.state.report_1_startDate}
            endDate={this.state.report_1_endDate}
            cityId={
              this.props ? this.props?.user && this.props?.user.cityId : null
            }
            heading={
              showList === "सांख्यिकी"
                ? "प्रतिबंधक कारवाई (सांख्यिकी)"
                : "प्रतिबंधक कारवाई (यादी)"
            }
            allTotal={this.state.report1_Total}
            total={this.state.reportList_Total}
            cityName={this.getCityName(
              this.props?.user && this.props?.user.cityId
            )}
            user={this.props?.user?.role}
            report_type={
              showList === "सांख्यिकी"
                ? "प्रतिबंधक_कारवाई_count"
                : "प्रतिबंधक_कारवाई_list"
            }
            report_name="प्रतिबंधक कारवाई"
          /> */}
        </div>
        {this.renderAnalyticsListModal()}
        <Modal
          title="आरोपी प्रोफाइल"
          top
          visible={this.state.setCriminalViewModel}
          onOk={this.closeCriminalViewModel}
          onCancel={this.closeCriminalViewModel}
          width={95 + "%"}
        >
          <ViewFormModel
            key={this.props && this.props.user.id}
            dataStates={professionals}
            preventiveAction={this.state.preventiveAction}
          ></ViewFormModel>
        </Modal>
        <Modal
          title={t("crime_information")}
          top
          visible={this.state.showGunaDetails}
          onOk={this.closeGunaViewModel}
          onCancel={this.closeGunaViewModel}
          width={95 + "%"}
        >
          <ViewGunaDetails
            pc_crimetitles={professionals?.pc_crimetitles}
            dataStates={
              Array.isArray(professionals?.criminalViewList?.gunhaInfor) &&
              professionals?.criminalViewList?.gunhaInfor.length > 0
                ? professionals?.criminalViewList?.gunhaInfor
                : []
            }
            address={
              (Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo?.[0]?.address) ||
              ""
            }
            name={
              (Array.isArray(professionals?.criminalViewList?.basicInfo) &&
                professionals?.criminalViewList?.basicInfo?.[0]?.name) ||
              ""
            }
            loading={this.state.gunaLoading}
            user_details={this.props?.user}
            masterId={
              Array.isArray(professionals?.criminalViewList?.basicInfo) &&
              professionals?.criminalViewList?.basicInfo[0]
                ? professionals?.criminalViewList?.basicInfo[0].id
                : ""
            }
            closeGunaViewModel={this.closeGunaViewModel}
          ></ViewGunaDetails>
        </Modal>
      </Spin>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}

const connectedReportsPreventive = connect(mapStateToProps)(ReportPreventive);
export { connectedReportsPreventive as ReportPreventive };
